export const TAKING_LONGER_THAN_EXPECTED_MESSAGE = {
  english: "This is taking longer than expected, please wait",
  hindi: "यह अपेक्षा से अधिक समय ले रहा है, कृपया प्रतीक्षा करें",
  spanish: "Esto está tardando más de lo esperado, por favor espere",
  french: "Cela prend plus de temps que prévu, veuillez patienter",
  german: "Dies dauert länger als erwartet, bitte warten",
  italian: "Questo sta richiedendo più tempo del previsto, attendere prego",
  portuguese: "Isso está demorando mais do que o esperado, por favor aguarde",
  russian: "Это занимает больше времени, чем ожидалось, пожалуйста, подождите",
  japanese: "予想より時間がかかっています。しばらくお待ちください",
  korean: "예상보다 시간이 오래 걸리고 있습니다. 잠시만 기다려 주세요",
  chinese: "这比预期的时间要长，请稍候",
  arabic: "هذا يستغرق وقتاً أطول من المتوقع، يرجى الانتظار",
  turkish: "Bu beklenenden daha uzun sürüyor, lütfen bekleyin",
  dutch: "Dit duurt langer dan verwacht, even geduld alstublieft",
  polish: "To trwa dłużej niż oczekiwano, proszę czekać",
  vietnamese: "Việc này mất nhiều thời gian hơn dự kiến, vui lòng đợi",
  thai: "กำลังใช้เวลานานกว่าที่คาดไว้ กรุณารอสักครู่",
  indonesian: "Ini memakan waktu lebih lama dari yang diharapkan, harap tunggu",
  filipino: "Ito ay tumatagal nang higit sa inaasahan, pakihintay",
  bengali:
    "এটি প্রত্যাশিত সময়ের চেয়ে বেশি সময় নিচ্ছে, অনুগ্রহ করে অপেক্ষা করুন",
  tamil:
    "இது எதிர்பார்த்ததை விட அதிக நேரம் எடுக்கிறது, தயவுசெய்து காத்திருங்கள்",
  telugu: "ఇది ఊహించిన దాని కంటే ఎక్కువ సమయం తీసుకుంటోంది, దయచేసి వేచి ఉండండి",
  kannada:
    "ಇದು ನಿರೀಕ್ಷಿತಕ್ಕಿಂತ ಹೆಚ್ಚು ಸಮಯ ತೆಗೆದುಕೊಳ್ಳುತ್ತಿದೆ, ದಯವಿಟ್ಟು ನಿರೀಕ್ಷಿಸಿ",
  malayalam:
    "ഇത് പ്രതീക്ഷിച്ചതിലും കൂടുതൽ സമയമെടുക്കുന്നു, ദയവായി കാത്തിരിക്കുക",
  marathi: "हे अपेक्षेपेक्षा जास्त वेळ घेत आहे, कृपया प्रतीक्षा करा",
  gujarati: "આ અપેક્ષા કરતાં વધુ સમય લઈ રહ્યું છે, કૃપા કરીને રાહ જુઓ",
  punjabi: "ਇਹ ਉਮੀਦ ਨਾਲੋਂ ਜ਼ਿਆਦਾ ਸਮਾਂ ਲੈ ਰਿਹਾ ਹੈ, ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ",
  urdu: "یہ توقع سے زیادہ وقت لے رہا ہے، براہ کرم انتظار کریں",
  swahili: "Hii inachukua muda mrefu kuliko ilivyotarajiwa, tafadhali subiri",
  yoruba: "Eyi n gba akoko ju bi a ti reti lo, jowo duro",
  igbo: "Nke a na-ewe oge karịa ka a tụrụ anya, biko chere",
  hausa:
    "Wannan yana ɗaukar lokaci fiye da yadda ake tsammani, don Allah ku jira",
  amharic: "ይህ ከተጠበቀው በላይ ጊዜ እየወሰደ ነው፣ እባክዎ ይጠብቁ",
  somali: "Tani waxay qaadanaysaa waqti ka badan inta la filayay, fadlan sug",
  zulu: "Lokhu kuthatha isikhathi esithe ukwedlula kunalokho obekulindelwe, sicela ulinde",
  xhosa: "Oku kuthatha ixesha elide kunokuba bekulindelekile, nceda ulinde",
  afrikaans: "Dit neem langer as verwag, wag asseblief",
  albanian: "Kjo po merr më shumë kohë se sa pritej, ju lutem prisni",
  armenian: "Սա ավելի երկար է տևում, քան սպասվում էր, խնդրում ենք սպասել",
  azerbaijani: "Bu gözləniləndən daha çox vaxt aparır, zəhmət olmasa gözləyin",
  basque: "Espero zena baino denbora gehiago hartzen ari da, mesedez itxaron",
  belarusian: "Гэта займае больш часу, чым чакалася, калі ласка, пачакайце",
  bosnian: "Ovo traje duže nego što se očekivalo, molimo sačekajte",
  bulgarian: "Това отнема повече време от очакваното, моля изчакайте",
  catalan: "Això està trigant més del que s'esperava, si us plau espereu",
  cebuano: "Kini nagdugay kaysa sa gipaabut, palihug hulat",
  chichewa:
    "Izi zikutenga nthawi yochuluka kuposa momwe zimayembekezeredwa, chonde dikirani",
  corsican: "Questu piglia più tempu di u previstu, aspettate per piacè",
  croatian: "Ovo traje duže nego što se očekivalo, molimo pričekajte",
  czech: "Trvá to déle, než se očekávalo, počkejte prosím",
  danish: "Dette tager længere tid end forventet, vent venligst",
  esperanto: "Ĉi tio daŭras pli longe ol atendite, bonvolu atendi",
  estonian: "See võtab oodatust kauem aega, palun oodake",
  finnish: "Tämä kestää odotettua kauemmin, odota hetki",
  frisian: "Dit duorret langer as ferwachte, wachtsje asjebleaft",
  galician: "Isto está a levar máis tempo do esperado, por favor agarde",
  georgian: "ეს მოსალოდნელზე მეტ დროს მოითხოვს, გთხოვთ დაელოდოთ",
  greek:
    "Αυτό παίρνει περισσότερο χρόνο από το αναμενόμενο, παρακαλώ περιμένετε",
  haitian: "Sa pran plis tan pase sa nou t ap tann lan, tanpri tann",
  hmong: "Qhov no siv sij hawm ntev dua li qhov xav tau, thov tos",
  hungarian: "Ez a vártnál tovább tart, kérjük várjon",
  icelandic: "Þetta tekur lengri tíma en búist var við, vinsamlegast bíðið",
  javanese:
    "Iki njupuk wektu luwih suwe tinimbang sing dikarepake, tulung ngenteni",
  kazakh: "Бұл күткеннен көп уақыт алуда, өтінемін күтіңіз",
  khmer: "វាចំណាយពេលយូរជាងការរំពឹងទុក សូមរង់ចាំ",
  kurdish: "Ev ji ya ku tê payîn dirêjtir dike, ji kerema xwe bisekinin",
  kyrgyz: "Бул күтүлгөндөн көп убакыт алууда, сураныч күтө туруңуз",
  lao: "ນີ້ໃຊ້ເວລາດົນກວ່າທີ່ຄາດໄວ້, ກະລຸນາລໍຖ້າ",
  latin: "Hoc diutius quam expectatum est sumit, quaeso exspecta",
  latvian: "Tas aizņem ilgāku laiku nekā gaidīts, lūdzu, uzgaidiet",
  lithuanian: "Tai užima daugiau laiko nei tikėtasi, prašome palaukti",
  luxembourgish: "Dëst dauert méi laang wéi erwaart, waart wannechgelift",
  macedonian: "Ова трае подолго од очекуваното, ве молиме почекајте",
  malagasy: "Izany dia maharitra kokoa noho ny nantenaina, azafady andraso",
  maltese: "Dan qed jieħu aktar żmien milli mistenni, jekk jogħġbok stenna",
  maori: "Kei te roa ake tēnei i tō tūmanako, tēnā koa tatari",
  mongolian:
    "Энэ нь төсөөлж байснаас илүү их цаг хугацаа шаардаж байна, түр хүлээнэ үү",
  myanmar:
    "ဤအရာသည် မျှော်လင့်ထားသည်ထက် အချိန်ပိုကြာနေပါသည်၊ ကျေးဇူးပြု၍ စောင့်ပါ",
  nepali:
    "यो अपेक्षा गरिएको भन्दा बढी समय लिइरहेको छ, कृपया प्रतीक्षा गर्नुहोस्",
  norwegian: "Dette tar lengre tid enn forventet, vennligst vent",
  pashto: "دا د تمې څخه ډیر وخت نیسي، مهرباني وکړئ انتظار وکړئ",
  persian: "این بیشتر از حد انتظار طول می‌کشد، لطفاً صبر کنید",
  romanian:
    "Aceasta durează mai mult decât era de așteptat, vă rugăm așteptați",
  scots: "This is takin langer than expectit, please wait",
  serbian: "Ово траје дуже него што се очекивало, молимо сачекајте",
  sesotho:
    "Sena se nka nako e telele ho feta kamoo ho neng ho lebelletsoe, ka kopo ema",
  shona:
    "Izvi zviri kutora nguva yakareba kupfuura zvaitarisirwa, ndapota mirira",
  sindhi: "هي توقع کان وڌيڪ وقت وٺي رهيو آهي، مهرباني ڪري انتظار ڪريو",
  sinhala:
    "මෙය බලාපොරොත්තු වූවාට වඩා වැඩි කාලයක් ගත වෙමින් පවතී, කරුණාකර රැඳී සිටින්න",
  slovak: "Trvá to dlhšie, ako sa očakávalo, počkajte prosím",
  slovenian: "To traja dlje, kot je bilo pričakovano, prosimo počakajte",
  sundanese: "Ieu nyandak waktos langkung lami ti anu disangka, mangga antosan",
  swedish: "Detta tar längre tid än förväntat, vänligen vänta",
  tajik: "Ин аз интизор дарозтар вақт мегирад, лутфан интизор шавед",
  tatar: "Бу көтелгәннән озаграк вакыт ала, зинһар көтегез",
  turkmen: "Bu garaşylandan has köp wagt alýar, haýyş edýäris garaşyň",
  ukrainian: "Це займає більше часу, ніж очікувалося, будь ласка, зачекайте",
  uyghur: "بۇ ئويلىغاندىن كۆپ ۋاقىت ئېلىۋاتىدۇ، ساقلاپ تۇرۇڭ",
  uzbek: "Bu kutilganidan ko'proq vaqt olmoqda, iltimos kuting",
  welsh:
    "Mae hyn yn cymryd mwy o amser na'r disgwyl, arhoswch os gwelwch yn dda",
  yiddish: "דאָס נעמט לענגער ווי דערוואַרט, ביטע וואַרטן",
  irish:
    "Tá sé seo ag tógáil níos faide ná mar a rabhthas ag súil leis, fan le do thoil",
  "haitian creole": "Sa ap pran plis tan pase sa nou te atann, tanpri tann",
  "traditional chinese": "這比預期的時間還要長，請稍候",
  oriya: "ଏହା ଆଶାଯାଉଥିବାଠାରୁ ବେସି ସମୟ ନେଉଛି, ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ",
  "malaysian malay":
    "Ini mengambil masa lebih lama daripada yang dijangkakan, sila tunggu",
  malay: "Ani lambat dari biasa, tunggu dulu ah",
  tagalog: "Mas tumatagal ito kaysa sa inaasahan, mangyaring maghintay",
  burmese: "၎င်းသည် မျှော်လင့်ထားသည်ထက် ပိုကြာသည်၊ ကျေးဇူးပြု၍ စောင့်ပါ။",
  hebrew: "זה לוקח יותר זמן מהצפוי, אנא המתן",
};

export const COMPOSE_MESSAGE_PLACEHOLDER = {
  english: "Compose your message",
  hindi: "अपना संदेश लिखें",
  spanish: "Escribe tu mensaje",
  french: "Rédigez votre message",
  german: "Verfasse deine Nachricht",
  italian: "Scrivi il tuo messaggio",
  portuguese: "Escreva sua mensagem",
  russian: "Напишите своё сообщение",
  japanese: "メッセージを作成してください",
  korean: "메시지를 작성하세요",
  chinese: "撰写您的消息",
  arabic: "اكتب رسالتك",
  turkish: "Mesajınızı yazın",
  dutch: "Stel je bericht op",
  polish: "Napisz swoją wiadomość",
  vietnamese: "Soạn tin nhắn của bạn",
  thai: "เขียนข้อความของคุณ",
  indonesian: "Tulis pesan Anda",
  filipino: "Gumawa ng iyong mensahe",
  bengali: "আপনার বার্তা লিখুন",
  tamil: "உங்கள் செய்தியை எழுதுங்கள்",
  telugu: "మీ సందేశాన్ని రాయండి",
  kannada: "ನಿಮ್ಮ ಸಂದೇಶವನ್ನು ಬರೆಯಿರಿ",
  malayalam: "നിങ്ങളുടെ സന്ദേശം എഴുതുക",
  marathi: "आपला संदेश लिहा",
  gujarati: "તમારું સંદેશો લખો",
  punjabi: "ਆਪਣਾ ਸੁਨੇਹਾ ਲਿਖੋ",
  urdu: "اپنا پیغام لکھیں",
  swahili: "Andika ujumbe wako",
  yoruba: "Kọ ifiranṣẹ rẹ",
  igbo: "Dee ozi gị",
  hausa: "Rubuta saƙonka",
  amharic: "መልእክትዎን ያንብቡ",
  somali: "Qor fariintaada",
  zulu: "Bhala umlayezo wakho",
  xhosa: "Bhala umyalezo wakho",
  afrikaans: "Skryf jou boodskap",
  albanian: "Shkruaj mesazhin tënd",
  armenian: "Գրեք ձեր հաղորդագրությունը",
  azerbaijani: "Mesajınızı yazın",
  basque: "Idatzi zure mezua",
  belarusian: "Напішыце сваё паведамленне",
  bosnian: "Napiši svoju poruku",
  bulgarian: "Съставете съобщението си",
  catalan: "Escriu el teu missatge",
  cebuano: "Isulat ang imong mensahe",
  chichewa: "Lembani uthenga wanu",
  corsican: "Scrivite u vostru missaghju",
  croatian: "Napiši svoju poruku",
  czech: "Napište svou zprávu",
  danish: "Skriv din besked",
  esperanto: "Verku vian mesaĝon",
  estonian: "Koosta oma sõnum",
  finnish: "Kirjoita viestisi",
  frisian: "Skriuw dyn berjocht",
  galician: "Escribe a túa mensaxe",
  georgian: "შეადგინეთ თქვენი შეტყობინება",
  greek: "Συντάξτε το μήνυμά σας",
  haitian: "Ekri mesaj ou",
  hmong: "Sau koj cov lus",
  hungarian: "Írja meg az üzenetét",
  icelandic: "Samsettu skilaboðin þín",
  javanese: "Tulis pesen sampeyan",
  kazakh: "Хабарламаңызды жазыңыз",
  khmer: "សរសេរសាររបស់អ្នក",
  kurdish: "Peyama xwe binivîse",
  kyrgyz: "Билдирүүңүздү жазыңыз",
  lao: "ຂຽນຂໍ້ຄວາມຂອງທ່ານ",
  latin: "Nuntium tuum compone",
  latvian: "Sastādiet savu ziņojumu",
  lithuanian: "Sukurkite savo žinutę",
  luxembourgish: "Schreift Äre Message",
  macedonian: "Состави ја пораката",
  malagasy: "Soraty ny hafatrao",
  maltese: "Ikteb il-messaġġ tiegħek",
  maori: "Tuhia tō karere",
  mongolian: "Мессежээ бичнэ үү",
  myanmar: "သင့်မက်ဆေ့ခ်ျရေးပါ",
  nepali: "आफ्नो सन्देश लेख्नुहोस्",
  norwegian: "Skriv meldingen din",
  pashto: "خپل پیغام ولیکئ",
  persian: "پیام خود را بنویسید",
  romanian: "Compune mesajul tău",
  scots: "Compose yer message",
  serbian: "Napiši svoju poruku",
  sesotho: "Ngola molaetsa oa hau",
  shona: "Nyora meseji yako",
  sindhi: "پنھنجو پيغام لکو",
  sinhala: "ඔබගේ පණිවිඩය ලියන්න",
  slovak: "Napíšte svoju správu",
  slovenian: "Sestavite svoje sporočilo",
  sundanese: "Tulis seratan anjeun",
  swedish: "Skriv ditt meddelande",
  tajik: "Паёми худро нависед",
  tatar: "Хәбәрегезне языгыз",
  turkmen: "Hatyňyzy ýazyň",
  ukrainian: "Напишіть своє повідомлення",
  uyghur: "ئۇچۇرىڭىزنى يېزىڭ",
  uzbek: "Xabaringizni yozing",
  welsh: "Cyfansoddwch eich neges",
  yiddish: "שרייב דיין אָנזאָג",
  irish: "Cum do theachtaireacht",
  "haitian creole": "Ekri mesaj ou",
  "traditional chinese": "撰寫您的訊息",
  oriya: "ଆପଣଙ୍କର ବାର୍ତ୍ତା ଲେଖନ୍ତୁ",
  "malaysian malay": "Tulis mesej anda",
  malay: "Tulis kiriman mu",
  tagalog: "Isulat ang iyong mensahe",
  burmese: "သင့်စာကိုရေးပါ။",
  hebrew: "כתוב את ההודעה שלך",
};

export const RECENT_CONVERSATIONS_TITLE = {
  english: "Recent Conversations",
  hindi: "हाल की बातचीत",
  spanish: "Conversaciones Recientes",
  french: "Conversations Récentes",
  german: "Letzte Unterhaltungen",
  italian: "Conversazioni Recenti",
  portuguese: "Conversas Recentes",
  russian: "Недавние разговоры",
  japanese: "最近の会話",
  korean: "최근 대화",
  chinese: "最近的对话",
  arabic: "المحادثات الأخيرة",
  turkish: "Son Konuşmalar",
  dutch: "Recente Gesprekken",
  polish: "Ostatnie Rozmowy",
  vietnamese: "Cuộc Trò Chuyện Gần Đây",
  thai: "การสนทนาล่าสุด",
  indonesian: "Percakapan Terbaru",
  filipino: "Mga Kamakailang Usapan",
  bengali: "সাম্প্রতিক কথোপকথন",
  tamil: "சமீபத்திய உரையாடல்கள்",
  telugu: "ఇటీవలి సంభాషణలు",
  kannada: "ಇತ್ತೀಚಿನ ಸಂಭಾಷಣೆಗಳು",
  malayalam: "അടുത്തിടെ നടത്തിയ സംഭാഷണങ്ങൾ",
  marathi: "अलीकडील संभाषणे",
  gujarati: "તાજેતરના સંવાદો",
  punjabi: "ਤਾਜ਼ਾ ਗੱਲਬਾਤਾਂ",
  urdu: "حالیہ گفتگو",
  swahili: "Mazungumzo ya Hivi Karibuni",
  yoruba: "Ìbànújẹ Tó ṣẹṣẹ ṣẹlẹ",
  igbo: "Mkparịta ụka ọhụrụ",
  hausa: "Tattaunawa na Kwanan Nan",
  amharic: "የቅርብ ጊዜ ውይይቶች",
  somali: "Wadahadalladii Ugu Dambeeyay",
  zulu: "Izingxoxo Zakamuva",
  xhosa: "Iincoko Zamva nje",
  afrikaans: "Onlangse Gesprekke",
  albanian: "Bisedat e Fundit",
  armenian: "Վերջին Զրույցներ",
  azerbaijani: "Son Söhbətlər",
  basque: "Azken Elkarrizketak",
  belarusian: "Апошнія размовы",
  bosnian: "Nedavni Razgovori",
  bulgarian: "Скорошни Разговори",
  catalan: "Converses Recents",
  cebuano: "Bag-ohay nga mga Panaghisgot",
  chichewa: "Zokambirana Posachedwapa",
  corsican: "Conversazioni Recenti",
  croatian: "Nedavni Razgovori",
  czech: "Nedávné Rozhovory",
  danish: "Seneste Samtaler",
  esperanto: "Lastatempaj Konversacioj",
  estonian: "Hiljutised Vestlused",
  finnish: "Viimeisimmät Keskustelut",
  frisian: "Resinte Petearen",
  galician: "Conversas Recentes",
  georgian: "Ბოლო საუბრები",
  greek: "Πρόσφατες Συνομιλίες",
  haitian: "Dènye Konvèsasyon yo",
  hmong: "Kev Sib Tham Tseem Ceeb",
  hungarian: "Legutóbbi Beszélgetések",
  icelandic: "Nýleg Samtöl",
  javanese: "Obrolan Anyar",
  kazakh: "Соңғы Әңгімелер",
  khmer: "ការសន្ទនាថ្មីៗ",
  kurdish: "Dozên Dawîn",
  kyrgyz: "Акыркы Сүйлөшүүлөр",
  lao: "ການສົນທະນາຫຼ້າສຸດ",
  latin: "Sermones Recentes",
  latvian: "Nesenās Sarunas",
  lithuanian: "Naujausi Pokalbiai",
  luxembourgish: "Rezent Gespréicher",
  macedonian: "Неодамнешни Разговори",
  malagasy: "Resadresaka Vao Haingana",
  maltese: "Konversazzjonijiet Riċenti",
  maori: "Ngā Kōrero o Nā Tata Nei",
  mongolian: "Сүүлд Яригдсан Яриа",
  myanmar: "မကြာသေးမီ ဆွေးနွေးမှုများ",
  nepali: "हालका कुराकानीहरू",
  norwegian: "Nylige Samtaler",
  pashto: "وروستي خبرې اترې",
  persian: "گفتگوهای اخیر",
  romanian: "Conversații Recente",
  scots: "Late Conversations",
  serbian: "Skorašnji Razgovori",
  sesotho: "Puisano ea Hau ea Haufinyane",
  shona: "Hurukuro Dzazvino",
  sindhi: "تازيون ڳالهه ٻولهه",
  sinhala: "මෑතක කතාබහ",
  slovak: "Nedávne Rozhovory",
  slovenian: "Nedavni Pogovori",
  sundanese: "Paguneman Anyar",
  swedish: "Senaste Samtal",
  tajik: "Сӯҳбатҳои Охирин",
  tatar: "Соңгы сөйләшүләр",
  turkmen: "Ýakynda Gepleşikler",
  ukrainian: "Останні Розмови",
  uyghur: "يېقىنقى پاراڭلار",
  uzbek: "So‘nggi Suhbatlar",
  welsh: "Sgyrsiau Diweddar",
  yiddish: "נעכטן שמועסן",
  irish: "Comhráite Le Déanaí",
  "haitian creole": "Dènye Konvèsasyon yo",
  "traditional chinese": "最近的對話",
  oriya: "ସମ୍ପ୍ରତିକ କଥାବାର୍ତ୍ତାଗୁଡ଼ିକ",
  "malaysian malay": "Perbualan Terkini",
  malay: "Cakap-cakap baru saja",
  tagalog: "Mga Kamakailang Pag-uusap",
  burmese: "လတ်တလော စကားဝိုင်းများ",
  hebrew: "שיחות אחרונות",
};

export const ACCEPT_MESSAGE = {
  english: "Accept",
  hindi: "स्वीकार करें",
  spanish: "Aceptar",
  french: "Accepter",
  german: "Akzeptieren",
  italian: "Accetta",
  portuguese: "Aceitar",
  russian: "Принять",
  japanese: "受け入れる",
  korean: "수락하다",
  chinese: "接受",
  arabic: "قبول",
  turkish: "Kabul et",
  dutch: "Accepteren",
  polish: "Zaakceptuj",
  vietnamese: "Chấp nhận",
  thai: "ยอมรับ",
  indonesian: "Terima",
  malay: "Terima",
  filipino: "Tanggapin",
  bengali: "গ্রহণ করুন",
  tamil: "ஏற்கவும்",
  telugu: "ఆమోదించు",
  kannada: "ಒಪ್ಪಿಗೊ",
  malayalam: "സ്വീകരിക്കുക",
  marathi: "स्वीकार करा",
  gujarati: "સ્વીકાર કરો",
  punjabi: "ਸਵੀਕਾਰ ਕਰੋ",
  urdu: "قبول کریں",
  swahili: "Kubali",
  yoruba: "Gba",
  igbo: "Nabata",
  hausa: "Amince",
  amharic: "ተቀበል",
  somali: "Aqbal",
  zulu: "Amukela",
  xhosa: "Yamkela",
  afrikaans: "Aanvaar",
  albanian: "Prano",
  armenian: "ընդունել",
  azerbaijani: "Qəbul et",
  basque: "Onartu",
  belarusian: "Прыняць",
  bosnian: "Prihvati",
  bulgarian: "Приеми",
  catalan: "Acceptar",
  cebuano: "Dawata",
  chichewa: "Vomereza",
  corsican: "Accetta",
  croatian: "Prihvati",
  czech: "Přijmout",
  danish: "Accepter",
  esperanto: "Akcepti",
  estonian: "Nõustu",
  finnish: "Hyväksy",
  frisian: "Akkeptearje",
  galician: "Aceptar",
  georgian: "მიღება",
  greek: "Αποδοχή",
  haitian: "Aksepte",
  hmong: "Txim tau",
  hungarian: "Elfogad",
  icelandic: "Samþykkja",
  javanese: "Tampa",
  kazakh: "Қабылдау",
  khmer: "ទទួលយក",
  kurdish: "Qebûl kirin",
  kyrgyz: "Кабыл алуу",
  lao: "ຮັບ",
  latin: "Accipere",
  latvian: "Pieņemt",
  lithuanian: "Priimti",
  luxembourgish: "Akzeptéieren",
  macedonian: "Прифати",
  malagasy: "Manaiky",
  maltese: "Aċċetta",
  maori: "Whakaaetia",
  mongolian: "Хүлээн авах",
  myanmar: "လက်ခံပါ",
  nepali: "स्वीकार गर्नुहोस्",
  norwegian: "Aksepter",
  pashto: "قبول کړئ",
  persian: "پذیرفتن",
  romanian: "Acceptă",
  scots: "Accept",
  serbian: "Prihvati",
  sesotho: "Amoda",
  shona: "Bvuma",
  sindhi: "قبول ڪريو",
  sinhala: "අනුමත කරන්න",
  slovak: "Akceptovať",
  slovenian: "Sprejmi",
  sundanese: "Nampi",
  swedish: "Acceptera",
  tajik: "Пазиранда",
  tatar: "Кабул итегез",
  turkmen: "Kabullamak",
  ukrainian: "Прийняти",
  uyghur: "قوبۇل قىلىڭ",
  uzbek: "Qabul qilish",
  welsh: "Derbyn",
  yiddish: "נעמן",
  irish: "Glac",
  "haitian creole": "Aksepte",
  "traditional chinese": "接受",
  oriya: "ଗ୍ରହଣ କରନ୍ତୁ",
  "malaysian malay": "Terima",
  tagalog: "Tanggapin",
  burmese: "လက်ခံပါတယ်။",
  hebrew: "לְקַבֵּל",
};

export const DECLINE_MESSAGE = {
  english: "Decline",
  hindi: "अस्वीकार करें",
  spanish: "Rechazar",
  french: "Refuser",
  german: "Ablehnen",
  italian: "Rifiuta",
  portuguese: "Recusar",
  russian: "Отклонить",
  japanese: "拒否する",
  korean: "거절하다",
  chinese: "拒绝",
  arabic: "رفض",
  turkish: "Reddet",
  dutch: "Afwijzen",
  polish: "Odrzuć",
  vietnamese: "Từ chối",
  thai: "ปฏิเสธ",
  indonesian: "Tolak",
  malay: "Tolak",
  filipino: "Tanggihan",
  bengali: "অস্বীকার করুন",
  tamil: "தள்ளுபடி செய்யவும்",
  telugu: "ఇంకితం చేయండి",
  kannada: "ನಿರಾಕರಿಸು",
  malayalam: "ปฏิเสธ",
  marathi: "नाकार करा",
  gujarati: "નકારી આપો",
  punjabi: "ਨਕਾਰ ਕਰੋ",
  urdu: "مسترد کریں",
  swahili: "Kataa",
  yoruba: "Kọ",
  igbo: "Jụ",
  hausa: "Karyata",
  amharic: "አልተቀበልም",
  somali: "Diid",
  zulu: "Phika",
  xhosa: "ukuhla",
  afrikaans: "Weier",
  albanian: "Refuzo",
  armenian: "Մերժել",
  azerbaijani: "Redd et",
  basque: "Galarazi",
  belarusian: "Адмовіць",
  bosnian: "Odbiti",
  bulgarian: "Отхвърлям",
  catalan: "Rebutjar",
  cebuano: "Dili",
  chichewa: "Pangani",
  corsican: "Rifiutà",
  croatian: "Odbiti",
  czech: "Odmítnout",
  danish: "Afvise",
  esperanto: "Rifuzi",
  estonian: "Keelduda",
  finnish: "Hylkää",
  frisian: "Ferkeare",
  galician: "Rexeitar",
  georgian: "გახსნა",
  greek: "Αρνείται",
  haitian: "Refize",
  hmong: "Tsis txais",
  hungarian: "Elutasít",
  icelandic: "Hafna",
  javanese: "Nolak",
  kazakh: "Қабылдамау",
  khmer: "បដិសេធ",
  kurdish: "Redd kirin",
  kyrgyz: "Жалгаштырууну четке кагуу",
  lao: "ບປະທານ",
  latin: "Reiectus",
  latvian: "Noraidīt",
  lithuanian: "Atmesti",
  luxembourgish: "Refuséieren",
  macedonian: "Одбиј",
  malagasy: "Tandremo",
  maltese: "Irrifjuta",
  maori: "Tūpato",
  mongolian: "Татгалзах",
  myanmar: "ပယ်ချပါ",
  nepali: "अस्वीकृत गर्नुहोस्",
  norwegian: "Avvis",
  pashto: "رد کړئ",
  persian: "رد کردن",
  romanian: "Declinează",
  scots: "Decline",
  serbian: "Odbiti",
  sesotho: "Hlahla",
  shona: "Kuramba",
  sindhi: "رد ڪريو",
  sinhala: "අපරිච්ඡේදනය කරන්න",
  slovak: "Odmietnuť",
  slovenian: "Zavrniti",
  sundanese: "Tolak",
  swedish: "Avvisa",
  tajik: "Рад кардан",
  tatar: "Рәд итегез",
  turkmen: "Reddetmek",
  ukrainian: "Відхилити",
  uyghur: "رەت قىلىڭ",
  uzbek: "Rad etish",
  welsh: "Gwrthod",
  yiddish: "אַרומנעמען",
  irish: "Diúltaigh",
  "haitian creole": "Refize",
  "traditional chinese": "拒絕",
  oriya: "ପରିକ୍ଷା କରନ୍ତୁ",
  "malaysian malay": "Tolak",
  tagalog: "Tanggihan",
  burmese: "ငြင်းသည်။",
  hebrew: "יְרִידָה",
};

// export const ERROR_CONNECTION_ISSUE = {
//   english: "Something went wrong. Check your connection and try again or contact us.",
//   hindi: "कुछ गलत हो गया। अपना कनेक्शन जांचें और पुनः प्रयास करें या हमसे संपर्क करें।",
//   spanish: "Algo salió mal. Verifica tu conexión e inténtalo de nuevo o contáctanos.",
//   french: "Une erreur s'est produite. Vérifiez votre connexion et réessayez ou contactez-nous.",
//   german: "Etwas ist schiefgelaufen. Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut oder kontaktieren Sie uns.",
//   italian: "Qualcosa è andato storto. Controlla la tua connessione e riprova oppure contattaci.",
//   portuguese: "Algo deu errado. Verifique sua conexão e tente novamente ou entre em contato conosco.",
//   russian: "Что-то пошло не так. Проверьте подключение и попробуйте снова или свяжитесь с нами.",
//   japanese: "問題が発生しました。接続を確認して再試行するか、お問い合わせください。",
//   korean: "문제가 발생했습니다. 연결 상태를 확인하고 다시 시도하거나 문의해 주세요.",
//   chinese: "出现问题。请检查您的连接并重试，或联系我们。",
//   arabic: "حدث خطأ ما. تحقق من الاتصال وحاول مرة أخرى أو اتصل بنا.",
//   turkish: "Bir şeyler yanlış gitti. Bağlantınızı kontrol edin ve tekrar deneyin ya da bizimle iletişime geçin.",
//   dutch: "Er is iets misgegaan. Controleer je verbinding en probeer het opnieuw of neem contact met ons op.",
//   polish: "Coś poszło nie tak. Sprawdź połączenie i spróbuj ponownie lub skontaktuj się z nami.",
//   vietnamese: "Đã xảy ra sự cố. Kiểm tra kết nối của bạn và thử lại hoặc liên hệ với chúng tôi.",
//   thai: "เกิดข้อผิดพลาด ตรวจสอบการเชื่อมต่อและลองใหม่อีกครั้งหรือ ติดต่อเรา",
//   indonesian: "Terjadi kesalahan. Periksa koneksi Anda dan coba lagi atau hubungi kami.",
//   filipino: "May nangyaring mali. Suriin ang iyong koneksyon at subukang muli o makipag-ugnayan sa amin.",
//   bengali: "কিছু ভুল হয়েছে। আপনার সংযোগ পরীক্ষা করুন এবং আবার চেষ্টা করুন অথবা আমাদের সাথে যোগাযোগ করুন।",
//   tamil: "ஏதோ தவறு நடந்துவிட்டது. உங்கள் இணைப்பைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும் அல்லது எங்களை தொடர்பு கொள்ளவும்.",
//   telugu: "ఏదో తప్పు జరిగింది. మీ కనెక్షన్‌ను తనిఖీ చేసి మళ్లీ ప్రయత్నించండి లేదా మమ్మల్ని సంప్రదించండి.",
//   kannada: "ಏನೋ ತಪ್ಪಾಗಿದೆ. ನಿಮ್ಮ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ ಮರುಪ್ರಯತ್ನಿಸಿ ಅಥವಾ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ.",
//   malayalam: "ഒരോതൊരു പിഴവുണ്ടായി. നിങ്ങളുടെ കണക്ഷൻ പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുകയോ ഞങ്ങളെ ബന്ധപ്പെടുകയോ ചെയ്യുക.",
//   marathi: "काहीतरी चूक झाली. तुमचे कनेक्शन तपासा आणि पुन्हा प्रयत्न करा किंवा आमच्याशी संपर्क साधा.",
//   gujarati: "કોઈ તકલીફ આવી છે. તમારું કનેક્શન તપાસો અને ફરી પ્રયત્ન કરો અથવા અમારો સંપર્ક કરો.",
//   punjabi: "ਕੁਝ ਗੜਬੜ ਹੋ ਗਈ। ਆਪਣਾ ਕਨੈਕਸ਼ਨ ਚੈੱਕ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ ਜਾਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
//   urdu: "کچھ غلط ہو گیا۔ اپنا کنیکشن چیک کریں اور دوبارہ کوشش کریں یا ہم سے رابطہ کریں۔",
//   swahili: "Kuna tatizo limetokea. Angalia muunganisho wako jaribu tena au wasiliana nasi.",
//   yoruba: "Ọ̀rọ̀ kan ṣẹlẹ̀. Ṣàyẹ̀wò asopọ rẹ, gbìyànjú lẹ́ẹ̀kansi tàbí kan sí wa.",
//   igbo: "Ihe mebiri. Lelee njikọ gị ma gbalịa ọzọ ma ọ bụ kpọtụrụ anyị.",
//   hausa: "Wani abu ya faru. Duba haɗin ka ka sake gwadawa ko tuntuɓi mu.",
//   amharic: "የተሳሳተ ነገር ተከስቷል። ግንኙነትዎን ያረጋግጡ እና እንደገና ይሞክሩ ወይም ያግኙን።",
//   somali: "Waxbaa qaldamay. Hubi xiriirkaaga oo isku day mar kale ama nala soo xiriir.",
//   zulu: "Kukhona okungahambanga kahle. Hlola uxhumano lwakho bese uzama futhi noma uxhumane nathi.",
//   xhosa: "Kukho into engahambanga kakuhle. Jonga uqhagamshelo lwakho uzame kwakhona okanye uqhagamshelane nathi.",
//   afrikaans: "Iets het verkeerd gegaan. Gaan kyk na jou verbinding en probeer weer of kontak ons.",
//   albanian: "Diçka shkoi keq. Kontrolloni lidhjen tuaj dhe provoni përsëri ose na kontaktoni.",
//   armenian: "Ինչ-որ բան սխալ է ընթացել։ Ստուգեք կապը և կրկին փորձեք կամ կապ հաստատեք մեզ հետ։",
//   azerbaijani: "Nəsə səhv oldu. Bağlantınızı yoxlayın və yenidən cəhd edin və ya bizimlə əlaqə saxlayın.",
//   basque: "Zerbait gaizki atera da. Egiaztatu zure konexioa eta saiatu berriro edo jar zaitez gurekin harremanetan.",
//   belarusian: "Нешта пайшло не так. Праверце падключэнне і паспрабуйце яшчэ раз або звяжыцеся з намі.",
//   bosnian: "Nešto je pošlo po zlu. Provjerite vezu i pokušajte ponovo ili nas kontaktirajte.",
//   bulgarian: "Нещо се обърка. Проверете връзката си и опитайте отново или се свържете с нас.",
//   catalan: "Alguna cosa ha anat malament. Comprova la teva connexió i torna-ho a intentar o contacta amb nosaltres.",
//   cebuano: "Naay sayop nga nahitabo. Susiha ang imong koneksyon ug sulayi usab o kontaka kami.",
//   chichewa: "Chinachitika cholakwika. Onani kulumikizana kwanu ndiyesani kachiwiri kapena tiuzeni.",
//   corsican: "Qualcosa hè andatu male. Verificate a vostra cunnessione è pruvate torna o cuntattateci.",
//   croatian: "Nešto je pošlo po zlu. Provjerite vezu i pokušajte ponovno ili nas kontaktirajte.",
//   czech: "Něco se pokazilo. Zkontrolujte připojení a zkuste to znovu nebo nás kontaktujte.",
//   danish: "Noget gik galt. Tjek din forbindelse og prøv igen eller kontakt os.",
//   esperanto: "Io fuŝiĝis. Kontrolu vian konekton kaj reprovu aŭ kontaktu nin.",
//   estonian: "Midagi läks valesti. Kontrollige oma ühendust ja proovige uuesti või võtke meiega ühendust.",
//   finnish: "Jotain meni pieleen. Tarkista yhteytesi ja yritä uudelleen tai ota meihin yhteyttä.",
//   frisian: "Der is wat misgien. Kontrolearje jo ferbining en besykje it op 'e nij of nim kontakt mei ús op.",
//   galician: "Algo saíu mal. Comproba a túa conexión e téntao de novo ou contacta connosco.",
//   georgian: "რაღაც შეცდომა მოხდა. შეამოწმეთ კავშირი და სცადეთ თავიდან ან დაგვიკავშირდით.",
//   greek: "Κάτι πήγε στραβά. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά ή επικοινωνήστε μαζί μας.",
//   haitian: "Yon bagay ale mal. Tcheke koneksyon ou epi eseye ankò oswa kontakte nou.",
//   hmong: "Muaj teeb meem. Tshawb xyuas koj qhov kev sib txuas thiab sim dua los yog hu rau peb.",
//   hungarian: "Valami elromlott. Ellenőrizd a kapcsolatod, próbáld újra vagy lépj kapcsolatba velünk.",
//   icelandic: "Eitthvað fór úrskeiðis. Athugaðu tenginguna þína og reyndu aftur eða hafðu samband við okkur.",
//   javanese: "Ana sing salah. Priksa sambunganmu lan coba maneh utawa hubungi kita.",
//   kazakh: "Бір нәрсе дұрыс болмады. Байланысыңызды тексеріп, қайта көріңіз немесе бізбен хабарласыңыз.",
//   khmer: "មានបញ្ហាអ្វីមួយ។ ពិនិត្យការតភ្ជាប់របស់អ្នកហើយព្យាយាមម្តងទៀត ឬ ទាក់ទងមកយើងខ្ញុំ។",
//   kurdish: "Tiştek çewt çû. Girêdayîyê xwe kontrol bike û dîsa biceribîne an bi me re têkilî dayne.",
//   kyrgyz: "Бир нерсе туура эмес болуп калды. Байланышыңызды текшерип кайра аракет кылыңыз же биз менен байланышыңыз.",
//   lao: "ມີບາງຢ່າງຜິດພາດ. ກວດສອບການເຊື່ອມຕໍ່ຂອງທ່ານ ແລະ ລອງໃໝ່ ຫຼື ຕິດຕໍ່ພວກເຮົາ.",
//   latin: "Aliquid erravit. Reprehende nexum tuum et iterum conare aut nos contacta.",
//   latvian: "Kaut kas nogāja greizi. Pārbaudiet savu savienojumu un mēģiniet vēlreiz vai sazinieties ar mums.",
//   lithuanian: "Įvyko klaida. Patikrinkite savo ryšį ir bandykite dar kartą arba susisiekite su mumis.",
//   luxembourgish: "Eppes ass schief gelaf. Kontrolléiert Är Verbindung a probéiert et nach eng Kéier oder kontaktéiert eis.",
//   macedonian: "Нешто тргна наопаку. Проверете ја вашата врска и обидете се повторно или контактирајте не.",
//   malagasy: "Nisy zavatra tsy nety. Hamarino ny fifandraisanao ary andramo indray na mifandraisa aminay.",
//   maltese: "Xi ħaġa marret ħażin. Iċċekkja l-konnessjoni tiegħek u erġa' pprova jew ikkuntattjana.",
//   maori: "I hapa tētahi mea. Tirohia tō hononga ka ngana anō, kātahi ka whakapā mai.",
//   mongolian: "Ямар нэгэн асуудал гарлаа. Холболтоо шалгаад дахин оролдоно уу эсвэл бидэнтэй холбогдоорой.",
//   myanmar: "တစ်ခုခုမှားနေပါတယ်။ သင်၏ကွန်နက်ရှင်ကိုစစ်ဆေးပြီး ပြန်လည်ကြိုးစားပါ သို့မဟုတ် ကျွန်ုပ်တို့အား ဆက်သွယ်ပါ။",
//   nepali: "केही गडबड भयो। आफ्नो जडान जाँच गर्नुहोस् र फेरि प्रयास गर्नुहोस् वा हामीलाई सम्पर्क गर्नुहोस्।",
//   norwegian: "Noe gikk galt. Sjekk tilkoblingen din og prøv igjen eller kontakt oss.",
//   pashto: "څه نا سم شو. خپل اتصال وګورئ او بیا هڅه وکړئ یا له موږ سره اړیکه ونیسئ.",
//   persian: "مشکلی پیش آمد. اتصال خود را بررسی کنید و دوباره تلاش کنید یا با ما تماس بگیرید.",
//   romanian: "Ceva n-a mers bine. Verifică conexiunea și încearcă din nou sau contactează-ne.",
//   scots: "Something went wrong. Check yer connection an try again or contact us.",
//   serbian: "Nešto je pošlo po zlu. Proverite vezu i pokušajte ponovo ili nas kontaktirajte.",
//   sesotho: "Ho na le phoso. Hlahloba khokahano ea hau 'me u leke hape kapa ikopanye le rona.",
//   shona: "Chimwe chinhu chakakanganisika. Tarisa kubatana kwako uye edza zvakare kana kuti taura nesu.",
//   sindhi: "ڪجهه غلط ٿي ويو. پنهنجي ڪنيڪشن کي جانچيو ۽ ٻيهر ڪوشش ڪريو يا اسان سان رابطو ڪريو.",
//   sinhala: "කිසියම් දෝෂයක් ඇතිවිය. ඔබගේ සම්බන්ධතාවය පරීක්ෂා කර නැවත උත්සාහ කරන්න හෝ අපව සම්බන්ධ කරන්න.",
//   slovak: "Niečo sa pokazilo. Skontrolujte svoje pripojenie a skúste to znova alebo nás kontaktujte.",
//   slovenian: "Nekaj je šlo narobe. Preverite svojo povezavo in poskusite znova ali nas kontaktirajte.",
//   sundanese: "Aya kasalahan. Pariksa sambungan anjeun sareng cobian deui atanapi ngahubungi kami.",
//   swedish: "Något gick fel. Kontrollera din anslutning och försök igen eller kontakta oss.",
//   tajik: "Чизе нодуруст рӯй дод. Пайвасти худро санҷед ва дубора кӯшиш кунед ё бо мо тамос гиред.",
//   tatar: "Бер нәрсә дә булмады. Бәйләнешегезне тикшерегез һәм яңадан карагыз яки безнең белән элемтәгә керегез.",
//   turkmen: "Bir zat nädogry boldy. Birikmäňizi barlaň we täzeden synanyşyň ýa-da biziň bilen habarlaşyň.",
//   ukrainian: "Щось пішло не так. Перевірте з'єднання і спробуйте знову або зв'яжіться з нами.",
//   uyghur: "بىر نەرسە خاتا بولدى. باغلىنىشىڭىزنى تەكشۈرۈپ قايتا سىناڭ ياكى بىز بىلەن ئالاقىلىشىڭ.",
//   uzbek: "Nimadir noto'g'ri ketdi. Ulanishni tekshiring va qayta urinib ko'ring yoki biz bilan bog'laning.",
//   welsh: "Aeth rhywbeth o'i le. Gwiriwch eich cysylltiad a cheisiwch eto neu cysylltwch â ni.",
//   yiddish: "עפּעס איז נישט אין אָרדער. טשעק דיין פֿאַרבינדונג און פּרובירן ווידער אָדער קאָנטאַקט אונדז.",
//   irish: "Chuaigh rud éigin mícheart. Seiceáil do nasc agus bain triail eile as nó déan teagmháil linn.",
//   "haitian creole": "Yon bagay ale mal. Tcheke koneksyon ou epi eseye ankò oswa kontakte nou.",
//   "traditional chinese": "出了些問題。請檢查您的連線並重試或聯繫我們。",
//   oriya: "କିଛି ଭୁଲ ଘଟିଛି। ଆପଣଙ୍କର ସଂଯୋଗ ଯାଞ୍ଚ କରନ୍ତୁ ଏବଂ ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ କିମ୍ବା ଆମ ସହିତ ଯୋଗାଯୋଗ କରନ୍ତୁ।",
//   "malaysian malay": "Sesuatu telah berlaku. Sila semak sambungan anda dan cuba semula atau hubungi kami.",
//   "malay": "Telah berlaku kesilapan. Sila periksa sambungan anda dan cuba lagi atau hubungi kami.",
//   tagalog: "Nagkaproblema. Suriin ang iyong koneksyon at subukang muli o makipag-ugnayan sa amin.",
//   burmese: "တစ်ခုခုမှားသွားသည်။ သင့်ချိတ်ဆက်မှုကို စစ်ဆေးပြီး ထပ်စမ်းကြည့်ပါ သို့မဟုတ် ကျွန်ုပ်တို့ထံ ဆက်သွယ်ပါ။",
//   hebrew: "משהו השתבש. בדוק את החיבור שלך ונסה שוב או צור איתנו קשר.",
// };

export const ERROR_CONNECTION_ISSUE = {
  english:
    "At present, we are managing a significant influx of requests, and we invite you to return in a little while for further support.",
  hindi:
    "फिलहाल, हम अनुरोधों की एक बड़ी मात्रा का प्रबंधन कर रहे हैं, और हम आपको कुछ समय बाद आने का निमंत्रण देते हैं।",
  spanish:
    "En este momento, estamos gestionando una gran cantidad de solicitudes y te invitamos a regresar en un rato para obtener más asistencia.",
  french:
    "Actuellement, nous gérons un afflux important de demandes et nous vous invitons à revenir dans un petit moment pour plus d'assistance.",
  german:
    "Derzeit verwalten wir eine große Anzahl von Anfragen und laden Sie ein, in kurzer Zeit für weitere Unterstützung zurückzukehren.",
  italian:
    "Al momento stiamo gestendo un notevole afflusso di richieste e ti invitiamo a tornare tra poco per ulteriore supporto.",
  portuguese:
    "No momento, estamos gerenciando um grande influxo de solicitações e convidamos você a retornar em pouco tempo para mais suporte.",
  russian:
    "В настоящее время мы обрабатываем большое количество запросов и приглашаем вас вернуться немного позже для дальнейшей поддержки.",
  japanese:
    "現在、多数のリクエストを処理しており、しばらく後に再度お越しいただくことをお勧めいたします。",
  korean:
    "현재 많은 요청을 처리하고 있으며, 잠시 후에 다시 방문해 주시기 바랍니다.",
  chinese: "目前我们正在处理大量请求，请您稍后再来获得进一步支持。",
  arabic:
    "في الوقت الحالي، نحن نتعامل مع تدفق كبير من الطلبات، وندعوكم للعودة بعد قليل للحصول على مزيد من الدعم.",
  turkish:
    "Şu anda önemli miktarda talep yönetiyoruz ve daha fazla destek için biraz sonra tekrar gelmenizi davet ediyoruz.",
  dutch:
    "Op dit moment beheren we een aanzienlijke toevloed van verzoeken en nodigen we je uit om over een tijdje terug te keren voor verdere ondersteuning.",
  polish:
    "Obecnie zarządzamy znacznym napływem żądań i zapraszamy do powrotu za chwilę w celu uzyskania dalszego wsparcia.",
  vietnamese:
    "Hiện tại, chúng tôi đang xử lý một lượng lớn yêu cầu và mời bạn quay lại sau ít phút để được hỗ trợ thêm.",
  thai: "ขณะนี้เรากำลังจัดการกับคำขอจำนวนมาก และขอเชิญให้คุณกลับมาในอีกสักครู่เพื่อรับการสนับสนุนเพิ่มเติม",
  indonesian:
    "Saat ini kami sedang menangani banyak permintaan dan mengundang Anda untuk kembali sebentar lagi untuk dukungan lebih lanjut.",
  filipino:
    "Sa ngayon, pinangangasiwaan namin ang malaking daloy ng mga kahilingan, at inuudyukan ka naming bumalik maya-maya para sa karagdagang suporta.",
  bengali:
    "বর্তমানে, আমরা প্রচুর অনুরোধ পরিচালনা করছি এবং আরও সহায়তার জন্য আপনাকে কিছুক্ষণ পরে ফিরে আসার জন্য আমন্ত্রণ জানাচ্ছি।",
  tamil:
    "தற்போது, நாங்கள் அதிக அளவிலான கோரிக்கைகளை நிர்வகித்து வருகிறோம், மேலும் ஆதரவுக்காக சிறிது நேரம் கழித்து திரும்பி வர உங்களை அழைக்கிறோம்.",
  telugu:
    "ప్రస్తుతం, మేము గణనీయమైన అభ్యర్థనలను నిర్వహిస్తున్నాము మరియు మరింత మద్దతు కోసం కొద్దిసేపు తర్వాత తిరిగి రావాలని మిమ్మల్ని ఆహ్వానిస్తున్నాము.",
  kannada:
    "ಪ್ರಸ್ತುತ, ನಾವು ಗಮನಾರ್ಹ ಪ್ರಮಾಣದ ವಿನಂತಿಗಳನ್ನು ನಿರ್ವಹಿಸುತ್ತಿದ್ದೇವೆ ಮತ್ತು ಹೆಚ್ಚಿನ ಸಹಾಯಕ್ಕಾಗಿ ಸ್ವಲ್ಪ ಸಮಯದ ನಂತರ ಹಿಂತಿರುಗಲು ನಿಮ್ಮನ್ನು ಆಹ್ವಾನಿಸುತ್ತೇವೆ.",
  malayalam:
    "നിലവിൽ, ഞങ്ങൾ ഗണ്യമായ അഭ്യർത്ഥനകൾ കൈകാര്യം ചെയ്യുന്നു, കൂടുതൽ പിന്തുണയ്ക്കായി കുറച്ച് സമയത്തിന് ശേഷം തിരികെ വരാൻ നിങ്ങളെ ക്ഷണിക്കുന്നു.",
  marathi:
    "सध्या, आम्ही मोठ्या प्रमाणात विनंत्या हाताळत आहोत आणि पुढील समर्थनासाठी थोड्या वेळाने परत येण्यासाठी आम्ही तुम्हाला आमंत्रण देतो.",
  gujarati:
    "હાલમાં, અમે નોંધપાત્ર વિનંતીઓનું સંચાલન કરી રહ્યા છીએ અને વધુ સહાય માટે થોડી વાર પછી પાછા આવવા માટે અમે તમને આમંત્રણ આપીએ છીએ.",
  punjabi:
    "ਫਿਲਹਾਲ, ਅਸੀਂ ਬਹੁਤ ਸਾਰੀਆਂ ਬੇਨਤੀਆਂ ਦਾ ਪ੍ਰਬੰਧਨ ਕਰ ਰਹੇ ਹਾਂ ਅਤੇ ਹੋਰ ਸਹਾਇਤਾ ਲਈ ਥੋੜ੍ਹੀ ਦੇਰ ਬਾਅਦ ਵਾਪਸ ਆਉਣ ਲਈ ਤੁਹਾਨੂੰ ਸੱਦਾ ਦਿੰਦੇ ਹਾਂ।",
  urdu: "فی الوقت، ہم کافی درخواستوں کا انتظام کر رہے ہیں، اور مزید مدد کے لیے تھوڑی دیر بعد واپس آنے کی دعوت دیتے ہیں۔",
  swahili:
    "Kwa sasa, tunaongoza idadi kubwa ya maombi, na tunakualika urudi baada ya muda mfupi kwa msaada zaidi.",
  yoruba:
    "Ni bayi, a n ṣakoso ọpọlọpọ awọn ibeere, ati pe a npe ọ pe ki o pada wa ni igba diẹ fun atilẹyin siwaju.",
  igbo: "Ugbu a, anyị na-ejikwa ọtụtụ arịrịọ, ma anyị na-akpọ gị ka ị laghachi n'oge nta maka nkwado ọzọ.",
  hausa:
    "A halin yanzu, muna tafiyar da adadi mai yawa na bukatu, kuma muna gayyata ku ku dawo bayan dan gajeren lokaci don samun ƙarin tallafi.",
  amharic:
    "አሁን፣ ብዙ ጥያቄዎችን እየቆጣጠርን ነው፣ እና ለተጨማሪ ድጋፍ በትንሹ ጊዜ ውስጥ እንዲመለሱ እንጋብዛለን።",
  somali:
    "Hadda, waxaan maaraynaa codsiyaal badan, waana kugu marti gelinnaa inaad ku soo noqoto wax yar ka dib taageero dheeraad ah.",
  zulu: "Okwamanje, silawula ukwanda okukhulu kwezicelo, futhi sikumema ukuthi ubuyele emva kwesikhathi esincane ukuze uthole ukusekwa okwengeziwe.",
  xhosa:
    "Okwangoku, silawula ukwanda okukhulu kwezicelo, kwaye sikumema ukuba ubuye emva kwexesha elincinci ukuze ufumane inkxaso eyongezelelweyo.",
  afrikaans:
    "Tans hanteer ons 'n beduidende toevloed van versoeke en nooi ons jou uit om binnekort terug te keer vir verdere ondersteuning.",
  albanian:
    "Aktualisht, ne po menaxhojmë një prurje të konsiderueshme kërkesash dhe ju ftojmë të ktheheni pas pak kohësh për mbështetje të mëtejshme.",
  armenian:
    "Ներկայումս մենք կարգավորում ենք հայտերի զգալի ներհոսք և հրավիրում ենք ձեզ մի փոքր ժամանակ անց վերադառնալ լրացուցիչ աջակցության համար:",
  azerbaijani:
    "Hazırda biz böyük miqdarda sorğunu idarə edirik və əlavə dəstək üçün bir az sonra qayıtmağa dəvət edirik.",
  basque:
    "Une honetan, eskari kopuru handi bat kudeatzen ari gara, eta laguntza gehiago lortzeko pixka bat geroago itzultzera gonbidatzen zaitugu.",
  belarusian:
    "У цяперашні час мы кіруем значным напорам запытаў і запрашаем вас вярнуцца праз некаторы час для далейшай падтрымкі.",
  bosnian:
    "Trenutno upravljamo značajnim priljevom zahtjeva i pozivamo vas da se vratite za malo za dodatnu podršku.",
  bulgarian:
    "В момента управляваме значителен приток от заявки и ви каним да се върнете след малко за допълнителна подкрепа.",
  catalan:
    "Actualment, estem gestionant un aflux significatiu de sol·licituds i us convidem a tornar d'aquí una estona per obtenir més suport.",
  cebuano:
    "Karon, nag-handle kami og daghan nga mga hangyo, ug giimbitar ka namo nga mobalik sa diyutay nga panahon para sa dugang nga suporta.",
  chichewa:
    "Pakali pano, tikuyang'anira kuchuluka kwa mapemphero, ndipo tikukuyitanirani kubwerera pang'ono kuti mulandire thandizo lowonjezera.",
  corsican:
    "Attualmente, ghjistimu un afflussu impurtante di richieste è vi invitemu à vultà in pocu tempu per un supportu supplementu.",
  croatian:
    "Trenutno upravljamo značajnim priljevom zahtjeva i pozivamo vas da se vratite za malo za dodatnu podršku.",
  czech:
    "V současné době spravujeme významný příliv požadavků a zveme vás, abyste se za chvíli vrátili pro další podporu.",
  danish:
    "I øjeblikket håndterer vi en betydelig tilstrømning af anmodninger og inviterer dig til at vende tilbage om lidt for yderligere support.",
  esperanto:
    "Nuntempe, ni administras signifan alflun de petoj, kaj ni invitas vin reveni post iom da tempo por plua subteno.",
  estonian:
    "Praegu haldame märkimisväärset päringute sissevoolu ja kutsume teid natuke hiljem tagasi tulema täiendava toe saamiseks.",
  finnish:
    "Tällä hetkellä hallitsemme merkittävää pyyntöjen määrää ja kutsumme sinut palaamaan pian lisätuen saamiseksi.",
  frisian:
    "Op dit stuit behearre wy in wichtige oanstream fan fersiken en nûgje wy jo út om oer in lyts bytsje werom te kommen foar fierdere stipe.",
  galician:
    "Actualmente, estamos xestionando un afluente significativo de solicitudes e convidámoste a volver nun pouco para obter máis apoio.",
  georgian:
    "ამჟამად ვმართავთ მოთხოვნების მნიშვნელოვან შემოდინებას და გიწვევთ, რომ ცოტა ხნის შემდეგ დაბრუნდეთ დამატებითი მხარდაჭერისთვის.",
  greek:
    "Αυτή τη στιγμή, διαχειριζόμαστε μια σημαντική εισροή αιτημάτων και σας προσκαλούμε να επιστρέψετε σε λίγο για περαιτέρω υποστήριξη.",
  haitian:
    "Kounye a, n ap jere yon kantite gwo demann yo, e nou envite nou tounen nan yon ti moman pou plis sipò.",
  hmong:
    "Tam sim no, peb tab tom tswj cov lus thov ntau heev, thiab peb caw koj rov qab los tom qab ib pliag rau kev txhawb nqa ntxiv.",
  hungarian:
    "Jelenleg jelentős mennyiségű kérést kezelünk, és meghívjuk, hogy egy kis idő múlva térjen vissza további támogatásért.",
  icelandic:
    "Eins og er stöndum við í miklu álagi beiðna og bjóðum þér að koma aftur eftir smá stund fyrir frekari aðstoð.",
  javanese:
    "Saiki, kita lagi ngatur akeh panjaluk, lan kita ngundang sampeyan mulih sawise sedhela kanggo dhukungan luwih.",
  kazakh:
    "Қазіргі уақытта біз өтініштердің айтарлықтай ағынын басқарып жатырмыз және қосымша қолдау үшін аздан кейін қайтып келуге шақырамыз.",
  khmer:
    "បច្ចុប្បន្ន យើងកំពុងគ្រប់គ្រងការស្នើសុំយ៉ាងច្រើន ហើយយើងសូមអញ្ជើញអ្នកត្រលប់មកវិញក្នុងពេលបន្តិចទៀតសម្រាប់ការគាំទ្របន្ថែម។",
  kurdish:
    "Niha, em gelek daxwazan rêve dikin û em we vexwendin ku hûn piştî demeke kurt vegerin ji bo piştgiriya zêdetir.",
  kyrgyz:
    "Азыркы учурда биз өтүнүчтөрдүн көп санын башкарып жатабыз жана кошумча колдоо үчүн бир аздан кийин кайтып келүүнү сунуштайбыз.",
  lao: "ໃນປັດຈຸບັນ, ພວກເຮົາກໍາລັງຈັດການກັບການຮ້ອງຂໍທີ່ຫຼາຍ, ແລະ ພວກເຮົາເຊີນທ່ານໃຫ້ກັບຄືນມາໃນອີກຈັກໂມງ ເພື່ອຮັບການສະໜັບສະໜຸນເພີ່ມເຕີມ.",
  latin:
    "In praesenti, grandem affluxum petitionum gubernamus et te invitamus ut paulo post redeas pro ulterius auxilium.",
  latvian:
    "Pašlaik mēs pārvaldām ievērojamu pieprasījumu pieplūdumu un aicinām jūs atgriezties pēc neilga laika papildu atbalstam.",
  lithuanian:
    "Šiuo metu tvarkome didelį užklausų srautą ir kviečiame jus grįžti po kurio laiko gauti papildomos pagalbos.",
  luxembourgish:
    "Am Moment geréiere mir eng bedeitend Unzuel u Requête an invitéiere Iech fir an enger klenger Zäit erëmzekommen fir weider Support.",
  macedonian:
    "Моментално управуваме со значителен прилив на барања и ве поканувам да се вратите наскоро за дополнителна поддршка.",
  malagasy:
    "Ankehitriny, mitantana fangatahana be dia be izahay ary manasa anao hiverina afaka kelikely izahay mba hahazoana fanampiana fanampiny.",
  maltese:
    "Bħalissa, qed nimmaniġġaw influss sinifikanti ta' talbiet u ninvitawkom terġgħu ftit ħin għal sapport ieħor.",
  maori:
    "I tenei wa, ka whakahaere matou i te rahi nui o nga tono, a ka powhiri matou koe kia hoki mai i roto i te wa poto mo te tautoko atu.",
  mongolian:
    "Одоо бид олон тооны хүсэлтийг удирдаж байгаа бөгөөд нэмэлт дэмжлэг авахын тулд удахгүй буцаж ирэхийг урьж байна.",
  myanmar:
    "လက်ရှိတွင် ကျွန်ုပ်တို့သည် တောင်းဆိုမှုများစွာကို ကိုင်တွယ်နေပြီး နောက်ထပ်အကူအညီအတွက် ခဏနောက်တွင် ပြန်လာရန် ဖိတ်ကြားပါသည်။",
  nepali:
    "हाल, हामी धेरै अनुरोधहरू व्यवस्थापन गरिरहेका छौं, र थप सहायताको लागि केही बेरपछि फर्कन आमन्त्रणा दिन्छौं।",
  norwegian:
    "For øyeblikket håndterer vi en betydelig tilstrømming av forespørsler og inviterer deg til å komme tilbake om litt for videre støtte.",
  pashto:
    "دا مهال، موږ د دوی غوښتنې تر سره کوو، او دوی ته اړتیا تاسو ته د ډیر کشرونو لپاره راوړو راستنیدو.",
  persian:
    "در حال حاضر، ما جریان قابل توجهی از درخواست‌ها را مدیریت می‌کنیم و شما را دعوت می‌کنیم که برای پشتیبانی بیشتر کمی بعد برگردید.",
  romanian:
    "În prezent, gestionăm un aflux semnificativ de cereri și vă invităm să reveniți într-o vreme pentru sprijin suplimentar.",
  scots:
    "At present, we're managin a significant influx o requests, an we invite ye tae return in a wee while fer further support.",
  serbian:
    "Trenutno upravljamo značajnim priljevom zahteva i pozivamo vas da se vratite za malo za dodatnu podršku.",
  sesotho:
    "Hajoale, re laola ketsahaletso e kholo ea likopo, 'me re u mema hore u khutlele ha hang ho fumana ts'ehetso e eketsehileng.",
  shona:
    "Parizvino, tiri kubata huwandu hwakakura hwezvirevo, uye tinokukoka kuti udzoke mukati menguva pfupi kuti uwane rubatsiro rwakawedzerwa.",
  sindhi:
    "في الوقت الحالي ، اسان وڏي مقدار ۾ درخواستن کي منظم ڪري رهيا آهيون ، ۽ اسان توهان کي دعوت ٿا ڏيون ته اضافي مدد لاءِ ٿورو دير بعد واپس اچو.",
  sinhala:
    "දැනට, අපි සැලකිය යුතු ඉල්ලීම් ප්‍රමාණයක් කළමනාකරණය කරමින් සිටින අතර, අතිරේක සහායක් සඳහා ටික වේලාවකට පසුව ආපසු එන ලෙස ඔබට ආරාධනා කරමු.",
  slovak:
    "V súčasnosti spravujeme významný prílev požiadaviek a pozývame vás, aby ste sa o chvíľu vrátili pre ďalšiu podporu.",
  slovenian:
    "Trenutno upravljamo s pomembnim prilivom zahtev in vas vabimo, da se čez kratek čas vrnete po nadaljnjo podporo.",
  sundanese:
    "Ayeuna, urang ngatur seueur pisan pamundut, sareng urang ngajak anjeun balik deui sakedap kanggo dukungan salajengna.",
  swedish:
    "För närvarande hanterar vi en betydande tillströmning av förfrågningar och inbjuder dig att återkomma om en liten stund för ytterligare stöd.",
  tajik:
    "Дар ҳоли ҳозир, мо ҷараёни назаррас дорандаи дархостҳоро идора мекунем ва шуморо даъват мекунем, ки барои дастгирии иловагӣ пас аз вақти кӯтоҳ баргардед.",
  tatar:
    "Хәзер безнең сораулар күп, безнең сезне кайтып килергә чакырабыз өстәмә ярдәм өчен.",
  turkmen:
    "Häzirki wagtda, biz köp sanly haýyşlary dolandyrýarys we goşmaça goldaw üçin azajyk wagtdan soň gaýdyp gelmegiňizi hödürleýäris.",
  ukrainian:
    "Зараз ми керуємо значним припливом запитів і запрошуємо вас повернутися через деякий час для подальшої підтримки.",
  uyghur:
    "ھازىر بىز نۇرغۇن ئىلتىماسلارنى باشقۇرۇۋاتىمىز، سىزنى قوشۇمچە قوللاش ئۈچۈن ئازدىن كېيىن قايتىپ كېلىشكە تەكلىپ قىلىمىز.",
  uzbek:
    "Hozirda biz ko'p sonli so'rovlarni boshqarayapmiz va sizni qo'shimcha yordam uchun ozgina vaqtdan keyin qaytishga taklif qilamiz.",
  welsh:
    "Ar hyn o bryd, rydym yn rheoli llif sylweddol o geisiadau ac yn eich gwahodd i ddychwelyd ymhen ychydig am gymorth pellach.",
  yiddish:
    "דערווייַל, מיר פירן א באַטייטיק צושטרוימונג פון בעטן און מיר פאַרבעטן אייך צו קומען צוריק אין אַ ביסל צייט פֿאַר ווייַטערדיק שטיצע.",
  irish:
    "Faoi láthair, táimid ag bainistiú isteach suntasach d'iarratais agus tugaimid cuireadh duit filleadh ar ball beag chun tacaíocht bhreise a fháil.",
  "haitian creole":
    "Koulye a, n ap jere yon gwo kantite demann epi nou envite nou tounen nan yon ti moman pou plis sipò.",
  "traditional chinese":
    "目前我們正在處理大量請求，邀請您稍後再回來獲得進一步支援。",
  oriya:
    "ବର୍ତ୍ତମାନ, ଆମେ ଅଧିକ ପରିମାଣରେ ଅନୁରୋଧ ପରିଚାଳନା କରୁଛୁ ଏବଂ ଅତିରିକ୍ତ ସହାୟତା ପାଇଁ ଅଳ୍ପ ସମୟ ପରେ ଫେରି ଆସିବାକୁ ଆମେ ଆପଣଙ୍କୁ ଆମନ୍ତ୍ରଣ କରୁଛୁ।",
  "malaysian malay":
    "Pada masa ini, kami sedang menguruskan permintaan yang banyak dan mengundang anda untuk kembali sebentar lagi untuk sokongan lanjut.",
  malay:
    "Pada masa ini, kami sedang menangani permintaan yang banyak dan mengundang anda untuk kembali sebentar lagi untuk sokongan selanjutnya.",
  tagalog:
    "Sa kasalukuyan, pinapangasiwaan namin ang malaking daloy ng mga kahilingan at inuudyukan ka naming bumalik maya-maya para sa karagdagang suporta.",
  burmese:
    "လက်ရှိတွင် ကျွန်ုပ်တို့သည် တောင်းဆိုမှုများစွာကို လုပ်ဆောင်နေပြီး နောက်ထပ်အကူအညီအတွက် ခဏနောက်တွင် ပြန်လာရန် ဖိတ်ခေါ်ပါသည်။",
  hebrew:
    "כרגע, אנו מנהלים זרם משמעותי של בקשות ומזמינים אתכם לחזור בעוד מעט לקבלת תמיכה נוספת.",
};

export const ERROR_529 = {
  english:
    "We are experiencing heavy traffic. Please try again later after a few minutes.",
  hindi:
    "हम भारी ट्रैफिक का सामना कर रहे हैं। कृपया कुछ मिनट बाद पुनः प्रयास करें।",
  spanish:
    "Estamos experimentando mucho tráfico. Por favor, inténtalo de nuevo en unos minutos.",
  french:
    "Nous connaissons un trafic important. Veuillez réessayer dans quelques minutes.",
  german:
    "Wir verzeichnen starken Verkehr. Bitte versuchen Sie es in ein paar Minuten erneut.",
  italian: "Stiamo riscontrando traffico intenso. Riprova tra qualche minuto.",
  portuguese:
    "Estamos enfrentando tráfego intenso. Tente novamente em alguns minutos.",
  russian:
    "У нас большая нагрузка. Пожалуйста, попробуйте снова через несколько минут.",
  japanese: "トラフィックが集中しています。数分後に再試行してください。",
  korean: "트래픽이 집중되고 있습니다. 몇 분 후에 다시 시도해 주세요.",
  chinese: "我们正在经历高流量。请几分钟后重试。",
  arabic: "نواجه ازدحاماً شديداً. يرجى المحاولة مرة أخرى بعد بضع دقائق.",
  turkish: "Yoğun trafik yaşıyoruz. Lütfen birkaç dakika sonra tekrar deneyin.",
  dutch:
    "We ondervinden veel verkeer. Probeer het over een paar minuten opnieuw.",
  polish: "Doświadczamy dużego ruchu. Spróbuj ponownie za kilka minut.",
  vietnamese:
    "Chúng tôi đang gặp lưu lượng truy cập cao. Vui lòng thử lại sau vài phút.",
  thai: "เรากำลังประสบปัญหาการเข้าใช้งานหนาแน่น กรุณาลองใหม่อีกครั้งหลังจากผ่านไปสองสามนาที",
  indonesian:
    "Kami mengalami lalu lintas yang padat. Silakan coba lagi setelah beberapa menit.",
  filipino:
    "Nakakaranas kami ng mataas na traffic. Pakisubukan muli makalipas ang ilang minuto.",
  bengali:
    "আমরা ভারী ট্রাফিকের সম্মুখীন হচ্ছি। কয়েক মিনিট পর আবার চেষ্টা করুন।",
  tamil:
    "நாங்கள் அதிக போக்குவரத்தை அனுபவிக்கிறோம். சில நிமிடங்களுக்குப் பிறகு மீண்டும் முயற்சிக்கவும்.",
  telugu:
    "మేము అధిక ట్రాఫిక్‌ను ఎదుర్కొంటున్నాము. దయచేసి కొన్ని నిమిషాల తర్వాత మళ్లీ ప్రయత్నించండి.",
  kannada:
    "ನಾವು ಭಾರೀ ಟ್ರಾಫಿಕ್ ಅನ್ನು ಅನುಭವಿಸುತ್ತಿದ್ದೇವೆ. ಕೆಲವು ನಿಮಿಷಗಳ ನಂತರ ಮರುಪ್ರಯತ್ನಿಸಿ.",
  malayalam:
    "ഞങ്ങൾ കനത്ത ട്രാഫിക് അനുഭവിക്കുന്നു. ദയവായി കുറച്ച് മിനിറ്റുകൾക്ക് ശേഷം വീണ്ടും ശ്രമിക്കുക.",
  marathi:
    "आम्हाला मोठी ट्रॅफिक येत आहे. कृपया काही मिनिटांनंतर पुन्हा प्रयत्न करा.",
  gujarati:
    "અમે ભારે ટ્રાફિકનો સામનો કરી રહ્યા છીએ. કૃપા કરીને થોડી મિનિટો પછી ફરી પ્રયાસ કરો.",
  punjabi:
    "ਅਸੀਂ ਭਾਰੀ ਟ੍ਰੈਫਿਕ ਦਾ ਸਾਹਮਣਾ ਕਰ ਰਹੇ ਹਾਂ। ਕਿਰਪਾ ਕਰਕੇ ਕੁਝ ਮਿੰਟ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  urdu: "ہم بہت زیادہ ٹریفک کا سامنا کر رہے ہیں۔ کرپیا کچھ منٹ بعد دوبارہ کوشش کریں۔",
  swahili:
    "Tunapata msongamano mkubwa. Tafadhali jaribu tena baada ya dakika chache.",
  yoruba: "A ń rí ìrìn àjò púpọ̀. Jọ̀wọ́ gbìyànjú lẹ́yìn ìṣẹ́jú díẹ̀.",
  igbo: "Anyị na-ahụ nnukwu okporo ụzọ. Biko nwaa ọzọ mgbe nkeji ole na ole gasịrị.",
  hausa:
    "Muna fuskantar babban zirga-zirga. Don Allah ku sake gwadawa bayan 'yan mintuna.",
  amharic: "ከፍተኛ ትራፊክ እያጋጠመን ነው። እባክዎን ከጥቂት ደቂቃዎች በኋላ እንደገና ይሞክሩ።",
  somali:
    "Waxaan la kulannay taraafikada badan. Fadlan mar kale isku day dhawr daqiiqo ka dib.",
  zulu: "Sibhekene nethafikhi eningi. Sicela uzame futhi ngemva kwemizuzu embalwa.",
  xhosa: "Sinamatrafiki amaninzi. Nceda uzame kwakhona emva kwemizuzu embalwa.",
  afrikaans:
    "Ons ervaar swaar verkeer. Probeer asseblief weer oor 'n paar minute.",
  albanian:
    "Po përjetojmë trafik të rëndë. Ju lutemi provoni përsëri pas disa minutash.",
  armenian:
    "Մենք ունենք ծանր թրաֆիկ: Խնդրում ենք կրկին փորձել մի քանի րոպե անց:",
  azerbaijani:
    "Ağır trafiklə üzləşirik. Zəhmət olmasa bir neçə dəqiqə sonra yenidən cəhd edin.",
  basque:
    "Trafiko handia jasaten ari gara. Mesedez, saiatu berriro minutu batzuen ondoren.",
  belarusian:
    "Мы адчуваем вялікі трафік. Калі ласка, паспрабуйце яшчэ раз праз некалькі хвілін.",
  bosnian:
    "Imamo veliki saobraćaj. Molimo pokušajte ponovo za nekoliko minuta.",
  bulgarian:
    "Изпитваме голям трафик. Моля, опитайте отново след няколко минути.",
  catalan:
    "Estem experimentant molt trànsit. Si us plau, torneu-ho a provar d'aquí a uns minuts.",
  cebuano:
    "Nag-antus kami og daghang traffic. Palihog sulayi usab pagkahuman sa pipila ka minuto.",
  chichewa:
    "Tikukumana ndi magalimoto ambiri. Chonde yesaninso pambuyo pa mphindi zingapo.",
  corsican:
    "Simu micca un trafficu pesu. Per piacè pruvate torna dopu à qualchi minutu.",
  croatian: "Imamo veliki promet. Molimo pokušajte ponovno za nekoliko minuta.",
  czech: "Máme velký provoz. Zkuste to prosím znovu za několik minut.",
  danish: "Vi oplever stor trafik. Prøv venligst igen om et par minutter.",
  esperanto:
    "Ni travivas gravan trafikegon. Bonvolu reprovi post kelkaj minutoj.",
  estonian: "Meil on suur liiklus. Palun proovige mõne minuti pärast uuesti.",
  finnish:
    "Meillä on vilkas liikenne. Yritä uudelleen muutaman minuutin kuluttua.",
  frisian:
    "Wy hawwe swier ferkear. Besykje it asjeblief opnij nei in pear minuten.",
  galician:
    "Estamos experimentando moito tráfico. Por favor, téntao de novo dentro duns minutos.",
  georgian:
    "ჩვენ ვაწყდებით მძიმე ტრაფიკს. გთხოვთ, სცადოთ ხელახლა რამდენიმე წუთის შემდეგ.",
  greek: "Αντιμετωπίζουμε βαριά κίνηση. Παρακαλώ δοκιμάστε ξανά σε λίγα λεπτά.",
  haitian: "Nou gen gwo sikilasyon. Tanpri eseye ankò apre kèk minit.",
  hmong: "Peb tab tom ntsib kev tsheb loj. Thov sim dua tom qab ob peb feeb.",
  hungarian:
    "Nagy forgalmat tapasztalunk. Kérjük, próbálja újra néhány perc múlva.",
  icelandic:
    "Við erum að upplifa mikla umferð. Vinsamlegast reyndu aftur eftir nokkrar mínútur.",
  javanese:
    "Kita ngalami lalu lintas abot. Mangga cobi maneh sawisé sawetara menit.",
  kazakh:
    "Біз қарқынды трафикке тап болдық. Бірнеше минуттан кейін қайта көріңіз.",
  khmer:
    "យើងកំពុងជួបប្រទះការចរាចរណ៍ច្រើន។ សូមព្យាយាមម្តងទៀតបន្ទាប់ពីប៉ុន្មាននាទី។",
  kurdish:
    "Em trafîka giran dijîn. Ji kerema xwe piştî çend hûrdeman dîsa biceribîne.",
  kyrgyz:
    "Биз оор трафикке туш болууда. Бир нече мүнөттөн кийин кайрадан аракет кылыңыз.",
  lao: "ພວກເຮົາກໍາລັງປະສົບກັບການເຄື່ອນໄຫວໜ້ານ້ອຍ. ກະລຸນາລອງໃໝ່ຫຼັງຈາກສອງສາມນາທີ.",
  latin: "Magnum negotium patimur. Quaeso iterum post aliquot minuta conare.",
  latvian: "Mums ir liela satiksme. Lūdzu, mēģiniet vēlreiz pēc dažām minūtēm.",
  lithuanian:
    "Mes patirame didelį srautą. Bandykite dar kartą po kelių minučių.",
  luxembourgish:
    "Mir hunn schwéieren Traffic. Probéiert et w.e.g. an e puer Minutten nach eng Kéier.",
  macedonian:
    "Имаме голем сообраќај. Ве молам обидете се повторно за неколку минути.",
  malagasy:
    "Misy fifamoivoizana be izahay. Mba andramo indray aorian'ny minitra vitsivitsy.",
  maltese:
    "Qed nesperjenzaw traffiku qawwi. Jekk jogħġbok ipprova għal darb'oħra wara ftit minuti.",
  maori:
    "He tawhiti rawa tā mātou. Tēnā koe whakamātau anō i muri i ētahi meneti.",
  mongolian:
    "Бид их ачаалалтай тулгарч байна. Хэдэн минутын дараа дахин оролдоно уу.",
  myanmar:
    "ကျွန်ုပ်တို့သည် လူသွားလူလာများနေသည်။ မိနစ်အနည်းငယ်အကြာတွင် ပြန်လည်ကြိုးစားပါ။",
  nepali:
    "हामीले भारी ट्राफिकको सामना गरिरहेका छौं। केही मिनेट पछि फेरि प्रयास गर्नुहोस्।",
  norwegian: "Vi opplever stor trafikk. Vennligst prøv igjen om noen minutter.",
  pashto:
    "موږ د ډیر ټرافیک سره مخ یو. مهرباني وکړئ د څو دقیقو وروسته بیا هڅه وکړئ.",
  persian: "ترافیک سنگینی داریم. لطفاً چند دقیقه بعد دوباره تلاش کنید.",
  romanian:
    "Avem trafic intens. Te rog să încerci din nou peste câteva minute.",
  scots: "We're haein heavy traffic. Please try again efter a few meenits.",
  serbian:
    "Imamo veliki saobraćaj. Molimo pokušajte ponovo za nekoliko minuta.",
  sesotho:
    "Re na le sephethephethe se seholo. Ka kopo leka hape kamora metsotso e mmalwa.",
  shona:
    "Tiri kuona traffic yakawanda. Ndapota edza zvakare mushure memamineti mashoma.",
  sindhi:
    "اسان کي تيز ٽريفڪ جو سامنو آهي. مهرباني ڪري ڪجهه منٽن بعد ٻيهر ڪوشش ڪريو.",
  sinhala:
    "අපට අධික තදබදයක් ඇති වේ. කරුණාකර මිනිත්තු කිහිපයකට පසු නැවත උත්සාහ කරන්න.",
  slovak: "Máme veľkú premávku. Skúste to prosím znova o niekoľko minút.",
  slovenian: "Imamo velik promet. Poskusite znova čez nekaj minut.",
  sundanese:
    "Kami ngalaman lalu lintas beurat. Mangga cobian deui saatos sababaraha menit.",
  swedish: "Vi upplever tung trafik. Försök igen om några minuter.",
  tajik:
    "Мо бор вазнини зиёдро пешнамеҳагоим. Лутфан баъди якчанд дақиқа такрор кӯшиш кунед.",
  tatar:
    "Без авыр трафик кичерәбез. Зинһар, берничә минуттан соң кабат карагыз.",
  turkmen:
    "Agyr traffik başdan geçirýäris. Birnäçe minutdan soň gaýtadan synanyşyň.",
  ukrainian:
    "Ми відчуваємо великий трафік. Будь ласка, спробуйте знову через кілька хвилин.",
  uyghur:
    "بىز قاتتىق ھەرىكەتكە دۇچ كەلدۇق. بىر نەچچە مىنۇتتىن كېيىن قايتا سىناڭ.",
  uzbek:
    "Biz og'ir trafik bilan duch kelmoqdamiz. Iltimos, bir necha daqiqadan so'ng qayta urinib ko'ring.",
  welsh: "Rydym yn profi traffig trwm. Ceisiwch eto mewn ychydig funudau.",
  yiddish: "מיר האָבן שווער טראַפיק. ביטע פּרובירן ווידער נאָך עטלעכע מינוט.",
  irish:
    "Táimid ag taithí tráchta trom. Bain triail eile as tar éis cúpla nóiméad.",
  "haitian creole": "Nou gen gwo sikilasyon. Tanpri eseye ankò apre kèk minit.",
  "traditional chinese": "我們正面臨大量流量。請在幾分鐘後重試。",
  oriya:
    "ଆମେ ଭାରୀ ଟ୍ରାଫିକ୍‌ର ସମ୍ମୁଖୀନ ହେଉଛୁ। ଦୟାକରି କିଛି ମିନିଟ୍ ପରେ ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
  "malaysian malay":
    "Kami mengalami trafik yang padat. Sila cuba semula selepas beberapa minit.",
  malay:
    "Kami menghadapi trafik yang tinggi. Sila cuba lagi selepas beberapa minit.",
  tagalog:
    "Nakakaranas kami ng mataas na traffic. Pakisubukan muli makalipas ang ilang minuto.",
  burmese:
    "ကျွန်ုပ်တို့သည် လမ်းအသုံးပြုမှု များနေပါသည်။ မိနစ်အနည်းငယ်အကြာတွင် ပြန်လည်ကြိုးစားပါ။",
  hebrew:
    "אנו חווים עומסי תנועה כבדים. אנא נסה שוב מאוחר יותר, לאחר מספר דקות.",
};

export const RETRY_LABEL = {
  english: "Retry",
  hindi: "पुनः प्रयास करें",
  spanish: "Reintentar",
  french: "Réessayer",
  german: "Wiederholen",
  italian: "Riprova",
  portuguese: "Tentar novamente",
  russian: "Повторить",
  japanese: "再試行",
  korean: "다시 시도",
  chinese: "重试",
  arabic: "أعد المحاولة",
  turkish: "Tekrar Dene",
  dutch: "Opnieuw proberen",
  polish: "Ponów próbę",
  vietnamese: "Thử lại",
  thai: "ลองอีกครั้ง",
  indonesian: "Coba Lagi",
  filipino: "Subukang muli",
  bengali: "আবার চেষ্টা করুন",
  tamil: "மீண்டும் முயற்சி செய்",
  telugu: "మళ్లీ ప్రయత్నించండి",
  kannada: "ಮರುಪ್ರಯತ್ನಿಸಿ",
  malayalam: "വീണ്ടും ശ്രമിക്കുക",
  marathi: "पुन्हा प्रयत्न करा",
  gujarati: "ફરી પ્રયત્ન કરો",
  punjabi: "ਮੁੜ ਕੋਸ਼ਿਸ਼ ਕਰੋ",
  urdu: "دوبارہ کوشش کریں",
  swahili: "Jaribu Tena",
  yoruba: "Tun gbiyanju",
  igbo: "Gbalịa ọzọ",
  hausa: "Sake Gwada",
  amharic: "እንደገና ይሞክሩ",
  somali: "Isku day mar kale",
  zulu: "Zama Futhi",
  xhosa: "Zama Kwakhona",
  afrikaans: "Probeer Weer",
  albanian: "Përpiquni përsëri",
  armenian: "Կրկին փորձել",
  azerbaijani: "Təkrar cəhd edin",
  basque: "Berriro saiatu",
  belarusian: "Паспрабуйце яшчэ раз",
  bosnian: "Pokušaj ponovo",
  bulgarian: "Опитайте отново",
  catalan: "Torna-ho a provar",
  cebuano: "Sulayi Pag-usab",
  chichewa: "Yesaninso",
  corsican: "Pruvate torna",
  croatian: "Pokušaj ponovno",
  czech: "Zkusit znovu",
  danish: "Prøv igen",
  esperanto: "Reprovu",
  estonian: "Proovi uuesti",
  finnish: "Yritä uudelleen",
  frisian: "Besykje op 'e nij",
  galician: "Téntao de novo",
  georgian: "თავიდან სცადეთ",
  greek: "Δοκιμάστε ξανά",
  haitian: "Reeseye",
  hmong: "Sim dua",
  hungarian: "Próbáld újra",
  icelandic: "Reyndu aftur",
  javanese: "Coba Maneh",
  kazakh: "Қайта көріңіз",
  khmer: "ព្យាយាម​ម្ដង​ទៀត",
  kurdish: "Dîsa biceribîne",
  kyrgyz: "Кайра аракет кылыңыз",
  lao: "ລອງຄືນ",
  latin: "Iterum conare",
  latvian: "Mēģināt vēlreiz",
  lithuanian: "Bandyti dar kartą",
  luxembourgish: "Nach eemol probéieren",
  macedonian: "Обиди се повторно",
  malagasy: "Andramo indray",
  maltese: "Erġa ipprova",
  maori: "Ngana anō",
  mongolian: "Дахин оролдоно уу",
  myanmar: "ထပ်မံကြိုးစားပါ",
  nepali: "फेरि प्रयास गर्नुहोस्",
  norwegian: "Prøv på nytt",
  pashto: "بیا هڅه وکړه",
  persian: "دوباره امتحان کنید",
  romanian: "Reîncearcă",
  scots: "Try Again",
  serbian: "Pokušaj ponovo",
  sesotho: "Leka Hape",
  shona: "Edzazve",
  sindhi: "وري ڪوشش ڪريو",
  sinhala: "නැවත උත්සාහ කරන්න",
  slovak: "Skúsiť znova",
  slovenian: "Poskusi znova",
  sundanese: "Coba Deui",
  swedish: "Försök igen",
  tajik: "Боз кӯшиш кунед",
  tatar: "Кабатлап карагыз",
  turkmen: "Gaýtadan synanyşyň",
  ukrainian: "Спробуйте ще раз",
  uyghur: "قايتا سىناڭ",
  uzbek: "Qayta urinib ko‘ring",
  welsh: "Ceisiwch eto",
  yiddish: "פרוביר ווידער",
  irish: "Bain triail eile as",
  "haitian creole": "Reeseye",
  "traditional chinese": "重試",
  oriya: "ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ",
  "malaysian malay": "Cuba semula",
  malay: "Cuba lagi",
  tagalog: "Subukan muli",
  burmese: "ပြန်ကြိုးစားပါ။",
  hebrew: "נסה שוב",
};

export const EMAIL_VALIDATION_MESSAGE = {
  "english (us)": "Enter a valid Email Address",
  "english (uk)": "Enter a valid Email Address",
  english: "Enter a valid Email Address",
  hindi: "एक वैध ईमेल पता दर्ज करें",
  spanish: "Ingrese una dirección de correo electrónico válida",
  french: "Saisissez une adresse e-mail valide",
  german: "Geben Sie eine gültige E-Mail-Adresse ein",
  italian: "Inserisci un indirizzo email valido",
  portuguese: "Digite um endereço de email válido",
  russian: "Введите действительный адрес электронной почты",
  japanese: "有効なメールアドレスを入力してください",
  korean: "유효한 이메일 주소를 입력하세요",
  chinese: "请输入有效的电子邮件地址",
  arabic: "أدخل عنوان بريد إلكتروني صالح",
  turkish: "Geçerli bir e-posta adresi girin",
  dutch: "Voer een geldig e-mailadres in",
  polish: "Wprowadź prawidłowy adres e-mail",
  vietnamese: "Nhập địa chỉ email hợp lệ",
  thai: "กรุณาใส่อีเมลที่ถูกต้อง",
  indonesian: "Masukkan alamat email yang valid",
  filipino: "Maglagay ng wastong email address",
  bengali: "একটি বৈধ ইমেইল ঠিকানা লিখুন",
  tamil: "சரியான மின்னஞ்சல் முகவரியை உள்ளிடவும்",
  telugu: "చెల్లుబాటు అయ్యే ఇమెయిల్ చిరునామాను నమోదు చేయండి",
  kannada: "ಮಾನ್ಯವಾದ ಇಮೇಲ್ ವಿಳಾಸವನ್ನು ನಮೂದಿಸಿ",
  malayalam: "സാധുവായ ഇമെയിൽ വിലാസം നൽകുക",
  marathi: "वैध ईमेल पत्ता प्रविष्ट करा",
  gujarati: "માન્ય ઈમેલ સરનામું દાખલ કરો",
  punjabi: "ਇੱਕ ਵੈਧ ਈਮੇਲ ਪਤਾ ਦਰਜ ਕਰੋ",
  urdu: "ایک درست ای میل ایڈریس درج کریں",
  swahili: "Ingiza anwani sahihi ya barua pepe",
  yoruba: "Tẹ adiresi imeeli to tọ sinu",
  igbo: "Tinye adreesị email ziri ezi",
  hausa: "Shigar da ingantaccen adireshin imel",
  amharic: "ትክክለኛ የኢሜይል አድራሻ ያስገቡ",
  somali: "Geli cinwaan email ah oo sax ah",
  zulu: "Faka ikheli le-email elivumelekile",
  xhosa: "Ngenisa idilesi ye-imeyile esebenzayo",
  afrikaans: "Voer 'n geldige e-posadres in",
  albanian: "Shkruani një adresë email të vlefshme",
  armenian: "Մուտքագրեք վավեր էլ․ փոստի հասցե",
  azerbaijani: "Etibarlı e-poçt ünvanı daxil edin",
  basque: "Sartu baliozko helbide elektroniko bat",
  belarusian: "Увядзіце сапраўдны адрас электроннай пошты",
  bosnian: "Unesite valjanu email adresu",
  bulgarian: "Въведете валиден имейл адрес",
  catalan: "Introduïu una adreça de correu electrònic vàlida",
  cebuano: "Pagsulod og hustong email address",
  chichewa: "Lembani imelo yolondola",
  corsican: "Inserite un indirizzu email validu",
  croatian: "Unesite valjanu email adresu",
  czech: "Zadejte platnou e-mailovou adresu",
  danish: "Indtast en gyldig e-mailadresse",
  esperanto: "Enigu validan retpoŝtan adreson",
  estonian: "Sisestage kehtiv e-posti aadress",
  finnish: "Syötä kelvollinen sähköpostiosoite",
  frisian: "Fier in jildich e-mailadres yn",
  galician: "Introduce un enderezo de correo electrónico válido",
  georgian: "შეიყვანეთ მოქმედი ელფოსტის მისამართი",
  greek: "Εισάγετε μια έγκυρη διεύθυνση email",
  haitian: "Antre yon adrès imèl ki valab",
  hmong: "Sau email chaw nyob kom raug",
  hungarian: "Adjon meg egy érvényes e-mail címet",
  icelandic: "Sláðu inn gilt netfang",
  javanese: "Lebokna alamat email sing bener",
  kazakh: "Жарамды электрондық пошта мекенжайын енгізіңіз",
  khmer: "បញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវ",
  kurdish: "Navnîşaneka emailê ya derbasdar binivîse",
  kyrgyz: "Туура электрондук почта дарегин киргизиңиз",
  lao: "ກະລຸນາໃສ່ທີ່ຢູ່ອີເມວທີ່ຖືກຕ້ອງ",
  latin: "Inscribe validam epistulae electronicae inscriptionem",
  latvian: "Ievadiet derīgu e-pasta adresi",
  lithuanian: "Įveskite galiojantį el. pašto adresą",
  luxembourgish: "Gitt eng gëlteg E-Mail-Adress an",
  macedonian: "Внесете валидна е-маил адреса",
  malagasy: "Ampidiro adiresy mailaka marina",
  maltese: "Daħħal indirizz tal-email validu",
  maori: "Whakaurunga he wāhitau īmēra tika",
  mongolian: "Хүчинтэй имэйл хаяг оруулна уу",
  myanmar: "မှန်ကန်သော အီးမေးလ်လိပ်စာထည့်ပါ",
  nepali: "मान्य इमेल ठेगाना प्रविष्ट गर्नुहोस्",
  norwegian: "Skriv inn en gyldig e-postadresse",
  pashto: "د ریښتیني بریښنالیک آدرس ولیکئ",
  persian: "آدرس ایمیل معتبر وارد کنید",
  romanian: "Introduceți o adresă de email validă",
  scots: "Enter a valid email address",
  serbian: "Unesite važeću email adresu",
  sesotho: "Kenya aterese ea lengolo-tsoibila e nepahetseng",
  shona: "Isa kero ye-email chaiyo",
  sindhi: "صحيح اي ميل پتو داخل ڪريو",
  sinhala: "වලංගු විද්‍යුත් තැපැල් ලිපිනයක් ඇතුළත් කරන්න",
  slovak: "Zadajte platnú e-mailovú adresu",
  slovenian: "Vnesite veljaven e-poštni naslov",
  sundanese: "Asupkeun alamat email anu sah",
  swedish: "Ange en giltig e-postadress",
  tajik: "Нишонии почтаи электронии дурустро ворид кунед",
  tatar: "Дөрес электрон почта адресын кертегез",
  turkmen: "Dogry e-poçta salgysyny giriziň",
  ukrainian: "Введіть дійсну адресу електронної пошти",
  uyghur: "توغرا ئېلېكترونلۇق خەت ئادرېسىنى كىرگۈزۈڭ",
  uzbek: "To'g'ri elektron pochta manzilini kiriting",
  welsh: "Rhowch gyfeiriad e-bost dilys",
  yiddish: "אַרײַנלייגן אַ גילטיק בליצפּאָסט אַדרעס",
  irish: "Cuir isteach seoladh ríomhphoist bailí",
  "haitian creole": "Antre yon adrès imèl ki valab",
  "traditional chinese": "請輸入有效的電子郵件地址",
  oriya: "ଏକ ବୈଧ ଇମେଲ ଠିକଣା ପ୍ରବିଷ୍ଟ କରନ୍ତୁ",
  "malaysian malay": "Masukkan alamat e-mel yang sah",
  malay: "Masukkan alamat e-mel yang betul",
  tagalog: "Maglagay ng wastong Email Address",
  burmese: "မှန်ကန်သော အီးမေးလ်လိပ်စာကို ထည့်သွင်းပါ။",
  hebrew: 'הזן כתובת דוא"ל חוקית',
};

export const PHONE_VALIDATION_MESSAGE = {
  "english (us)": "Please enter a valid phone number with country code",
  "english (uk)": "Please enter a valid phone number with country code",
  english: "Please enter a valid phone number with country code",
  hindi: "कृपया देश कोड के साथ एक वैध फोन नंबर दर्ज करें",
  spanish:
    "Por favor, ingrese un número de teléfono válido con el código de país",
  french: "Veuillez entrer un numéro de téléphone valide avec le code pays",
  german: "Bitte geben Sie eine gültige Telefonnummer mit Ländervorwahl ein",
  italian:
    "Inserisci un numero di telefono valido con il prefisso internazionale",
  portuguese:
    "Por favor, digite um número de telefone válido com o código do país",
  russian: "Пожалуйста, введите действительный номер телефона с кодом страны",
  japanese: "国番号を含む有効な電話番号を入力してください",
  korean: "국가 번호를 포함한 유효한 전화번호를 입력하세요",
  chinese: "请输入带有国家代码的有效电话号码",
  arabic: "يرجى إدخال رقم هاتف صالح مع رمز البلد",
  turkish: "Lütfen ülke koduyla birlikte geçerli bir telefon numarası girin",
  dutch: "Voer een geldig telefoonnummer met landcode in",
  polish: "Wprowadź prawidłowy numer telefonu z numerem kierunkowym kraju",
  vietnamese: "Vui lòng nhập số điện thoại hợp lệ bao gồm mã quốc gia",
  thai: "กรุณาใส่หมายเลขโทรศัพท์ที่ถูกต้องพร้อมรหัสประเทศ",
  indonesian: "Masukkan nomor telepon yang valid dengan kode negara",
  filipino:
    "Mangyaring maglagay ng wastong numero ng telepono kasama ang country code",
  bengali: "দয়া করে দেশের কোড সহ একটি বৈধ ফোন নম্বর লিখুন",
  tamil: "நாட்டுக் குறியீட்டுடன் சரியான தொலைபேசி எண்ணை உள்ளிடவும்",
  telugu: "దయచేసి దేశం కోడ్‌తో చెల్లుబాటు అయ్యే ఫోన్ నంబర్‌ను నమోదు చేయండి",
  kannada: "ದಯವಿಟ್ಟು ದೇಶದ ಕೋಡ್‌ನೊಂದಿಗೆ ಮಾನ್ಯವಾದ ಫೋನ್ ಸಂಖ್ಯೆಯನ್ನು ನಮೂದಿಸಿ",
  malayalam: "രാജ്യ കോഡ് സഹിതം സാധുവായ ഒരു ഫോൺ നമ്പർ നൽകുക",
  marathi: "कृपया देश कोडसह वैध फोन नंबर प्रविष्ट करा",
  gujarati: "કૃપા કરીને દેશના કોડ સાથે માન્ય ફોન નંબર દાખલ કરો",
  punjabi: "ਕਿਰਪਾ ਕਰਕੇ ਦੇਸ਼ ਦੇ ਕੋਡ ਦੇ ਨਾਲ ਇੱਕ ਵੈਧ ਫ਼ੋਨ ਨੰਬਰ ਦਰਜ ਕਰੋ",
  urdu: "براہ کرم ملک کے کوڈ کے ساتھ ایک درست فون نمبر درج کریں",
  swahili: "Tafadhali ingiza nambari ya simu halali yenye nambari ya nchi",
  yoruba: "Jọwọ tẹ nọmba tẹlifóònù to tọ pẹlu koodu orilẹ-ede",
  igbo: "Biko tinye nọmba ekwentị ziri ezi nwere koodu obodo",
  hausa: "Da fatan za a shigar da ingantaccen lambar waya tare da lambar ƙasa",
  amharic: "እባክዎን የአገር መለያ ቁጥር ያለው ትክክለኛ የስልክ ቁጥር ያስገቡ",
  somali: "Fadlan geli lambar taleefan oo sax ah oo wadata koodka dalka",
  zulu: "Sicela ufake inombolo yocingo evumelekile enekhodi yezwe",
  xhosa: "Nceda ufake inombolo yefowuni esebenzayo enekhowudi yelizwe",
  afrikaans: "Voer asseblief 'n geldige telefoonnommer met landkode in",
  albanian:
    "Ju lutemi shkruani një numër telefoni të vlefshëm me kodin e shtetit",
  armenian: "Խնդրում ենք մուտքագրել վավեր հեռախոսահամար՝ երկրի կոդով",
  azerbaijani:
    "Zəhmət olmasa ölkə kodu ilə etibarlı telefon nömrəsi daxil edin",
  basque: "Mesedez, sartu baliozko telefono-zenbaki bat herrialdeko kodearekin",
  belarusian: "Калі ласка, увядзіце сапраўдны нумар тэлефона з кодам краіны",
  bosnian: "Unesite važeći broj telefona s pozivnim brojem države",
  bulgarian: "Моля, въведете валиден телефонен номер с код на държавата",
  catalan: "Introduïu un número de telèfon vàlid amb el codi de país",
  cebuano:
    "Palihug pagsulod og hustong numero sa telepono nga naay country code",
  chichewa: "Chonde lembani nambala yafoni yolondola ndi nambala ya dziko",
  corsican:
    "Per piacè inserite un numeru di telefonu validu cù u codice di u paese",
  croatian: "Unesite valjan broj telefona s pozivnim brojem zemlje",
  czech: "Zadejte prosím platné telefonní číslo s předvolbou země",
  danish: "Indtast venligst et gyldigt telefonnummer med landekode",
  esperanto: "Bonvolu enigi validan telefonnumeron kun landkodo",
  estonian: "Palun sisestage kehtiv telefoninumber koos riigikoodiga",
  finnish: "Syötä kelvollinen puhelinnumero maatunnuksineen",
  frisian: "Fier asjebleaft in jildich telefoannûmer yn mei lânkoade",
  galician: "Introduza un número de teléfono válido co código do país",
  georgian: "გთხოვთ, შეიყვანოთ მოქმედი ტელეფონის ნომერი ქვეყნის კოდით",
  greek: "Εισαγάγετε έναν έγκυρο αριθμό τηλεφώνου με τον κωδικό χώρας",
  haitian: "Tanpri antre yon nimewo telefòn ki valab ak kòd peyi a",
  hmong: "Thov sau tus xov tooj kom raug nrog lub teb chaws code",
  hungarian: "Kérjük, adjon meg egy érvényes telefonszámot országkóddal",
  icelandic: "Vinsamlegast sláðu inn gilt símanúmer með landskóða",
  javanese: "Mangga lebokna nomer telepon sing bener karo kode negara",
  kazakh: "Ел коды бар жарамды телефон нөмірін енгізіңіз",
  khmer: "សូមបញ្ចូលលេខទូរស័ព្ទដែលត្រឹមត្រូវជាមួយលេខកូដប្រទេស",
  kurdish:
    "Ji kerema xwe bi koda welat re jimareyek têlefonê derbasdar binivîse",
  kyrgyz: "Өлкө коду менен туура телефон номерин киргизиңиз",
  lao: "ກະລຸນາໃສ່ເບີໂທລະສັບທີ່ถูกต้องພ້ອມກັບລະຫັດປະເທດ",
  latin: "Inscribe validam numerum telephonicum cum codice patriae",
  latvian: "Lūdzu, ievadiet derīgu tālruņa numuru ar valsts kodu",
  lithuanian: "Įveskite galiojantį telefono numerį su šalies kodu",
  luxembourgish: "Gitt w.e.g. eng gëlteg Telefonsnummer mat Landesvorwahl un",
  macedonian: "Внесете валиден телефонски број со код на државата",
  malagasy: "Ampidiro ny laharana finday marina misy kaody firenena",
  maltese:
    "Jekk jogħġbok daħħal numru tat-telefown validu bil-kodiċi tal-pajjiż",
  maori: "Whakaurunga he nama waea tika me te waehere whenua",
  mongolian: "Улсын кодтой хүчинтэй утасны дугаар оруулна уу",
  myanmar: "နိုင်ငံအလိုက်ကုဒ်ဖြင့် မှန်ကန်သော ဖုန်းနံပါတ်ကို ထည့်ပါ",
  nepali: "कृपया देशको कोडसहित मान्य फोन नम्बर प्रविष्ट गर्नुहोस्",
  norwegian: "Vennligst skriv inn et gyldig telefonnummer med landskode",
  pashto: "مهرباني وکړئ د هیواد کوډ سره د تلیفون سم شمیره ولیکئ",
  persian: "لطفاً شماره تلفن معتبر را به همراه کد کشور وارد کنید",
  romanian:
    "Vă rugăm să introduceți un număr de telefon valid cu prefixul țării",
  scots: "Please enter a valid phone number wi country code",
  serbian: "Unesite važeći broj telefona sa pozivnim brojem države",
  sesotho: "Kenya nomoro ea mohala e nepahetseng e nang le khoutu ea naha",
  shona: "Isa nhamba yefoni chaiyo ine kodhi yenyika",
  sindhi: "مهرباني ڪري ملڪ جي ڪوڊ سان صحيح فون نمبر داخل ڪريو",
  sinhala: "කරුණාකර රටේ කේතය සමඟ වලංගු දුරකථන අංකයක් ඇතුළත් කරන්න",
  slovak: "Zadajte platné telefónne číslo s predvoľbou krajiny",
  slovenian: "Vnesite veljavno telefonsko številko s klicno kodo države",
  sundanese: "Mangga asupkeun nomer telepon anu sah sareng kode nagara",
  swedish: "Ange ett giltigt telefonnummer med landskod",
  tajik: "Лутфан, рақами телефони дурустро бо коди кишвар ворид кунед",
  tatar: "Ил коды белән дөрес телефон номерын кертегез",
  turkmen: "Ýurt kody bilen dogry telefon belgisini giriziň",
  ukrainian: "Будь ласка, введіть дійсний номер телефону з кодом країни",
  uyghur: "دۆلەت კودى بىلەن توغرا تېلېفون نومۇرىنى كىرگۈزۈڭ",
  uzbek: "Iltimos, mamlakat kodi bilan to'g'ri telefon raqamini kiriting",
  welsh: "Rhowch rif ffôn dilys gyda chod gwlad",
  yiddish: "ביטע אַרײַנלייגן אַ גילטיק טעלעפאָן נומער מיט לאַנד קאָד",
  irish: "Cuir isteach uimhir theileafóin bhailí le cód tíre, le do thoil",
  "haitian creole": "Tanpri antre yon nimewo telefòn ki valab ak kòd peyi a",
  "traditional chinese": "請輸入帶有國家代码的有效電話號碼",
  oriya: "ଦୟାକରି ଦେଶ କୋଡ୍ ସହିତ ଏକ ବୈଧ ଫୋନ୍ ନମ୍ବର ପ୍ରବିଷ୍ଟ କରନ୍ତୁ",
  "malaysian malay": "Sila masukkan nombor telefon yang sah dengan kod negara",
  malay: "Sila masukkan nombor telefon yang betul dengan kod negara",
  tagalog:
    "Mangyaring maglagay ng wastong numero ng telepono kasama ang country code",
  burmese:
    "ကျေးဇူးပြု၍ နိုင်ငံကုဒ်ဖြင့် မှန်ကန်သော ဖုန်းနံပါတ်ကို ထည့်သွင်းပါ။",
  hebrew: "הזן מספר טלפון חוקי הכולל קידומת מדינה",
};

export const OTP_PLACEHOLDER_MESSAGE = {
  "english (us)": "Enter 6-digit OTP",
  "english (uk)": "Enter 6-digit OTP",
  english: "Enter 6-digit OTP",
  hindi: "6-अंकों का ओटीपी दर्ज करें",
  spanish: "Ingrese el OTP de 6 dígitos",
  french: "Entrez le code OTP à 6 chiffres",
  german: "Geben Sie den 6-stelligen OTP ein",
  italian: "Inserisci l'OTP a 6 cifre",
  portuguese: "Digite o OTP de 6 dígitos",
  russian: "Введите 6-значный OTP",
  japanese: "6桁のOTPを入力してください",
  korean: "6자리 OTP를 입력하세요",
  chinese: "请输入6位OTP验证码",
  arabic: "أدخل رمز التحقق (OTP) المكون من 6 أرقام",
  turkish: "6 haneli OTP'yi girin",
  dutch: "Voer de 6-cijferige OTP in",
  polish: "Wprowadź 6-cyfrowy kod OTP",
  vietnamese: "Nhập mã OTP 6 chữ số",
  thai: "กรุณาใส่รหัส OTP 6 หลัก",
  indonesian: "Masukkan 6 digit OTP",
  filipino: "Ilagay ang 6-digit na OTP",
  bengali: "৬-সংখ্যার ওটিপি লিখুন",
  tamil: "6 இலக்க OTP ஐ உள்ளிடவும்",
  telugu: "6-అంకెల OTPని నమోదు చేయండి",
  kannada: "6-ಅಂಕಿಯ OTP ನಮೂದಿಸಿ",
  malayalam: "6 അക്ക OTP നൽകുക",
  marathi: "6-अंकी ओटीपी प्रविष्ट करा",
  gujarati: "6-આંકડાનો OTP દાખલ કરો",
  punjabi: "6-ਅੰਕਾਂ ਦਾ OTP ਦਰਜ ਕਰੋ",
  urdu: "6 ہندسوں کا OTP درج کریں",
  swahili: "Ingiza OTP ya tarakimu 6",
  yoruba: "Tẹ OTP nọmba mẹfa sinu",
  igbo: "Tinye OTP nọmba isii",
  hausa: "Shigar da lambar OTP guda 6",
  amharic: "ባለ 6 አሃዝ OTP ያስገቡ",
  somali: "Geli 6-lambarka OTP-ga ah",
  zulu: "Faka i-OTP enezinto eziyisithupha",
  xhosa: "Ngenisa i-OTP enamanani ama-6",
  afrikaans: "Voer 6-syfer OTP in",
  albanian: "Shkruani OTP-në me 6 shifra",
  armenian: "Մուտքագրեք 6-նիշանոց OTP-ն",
  azerbaijani: "6 rəqəmli OTP-ni daxil edin",
  basque: "Sartu 6 digituko OTP",
  belarusian: "Увядзіце 6-значны OTP",
  bosnian: "Unesite 6-cifreni OTP",
  bulgarian: "Въведете 6-цифрен OTP",
  catalan: "Introduïu l'OTP de 6 dígits",
  cebuano: "Pagsulod og 6-digit nga OTP",
  chichewa: "Lembani nambala ya OTP ya manambala 6",
  corsican: "Inserite l'OTP di 6 cifre",
  croatian: "Unesite 6-znamenkasti OTP",
  czech: "Zadejte 6místný kód OTP",
  danish: "Indtast 6-cifret OTP",
  esperanto: "Enigu la 6-ciferan OTP",
  estonian: "Sisestage 6-kohaline OTP",
  finnish: "Syötä 6-numeroinen OTP",
  frisian: "Fier de 6-siferige OTP yn",
  galician: "Introduce o OTP de 6 díxitos",
  georgian: "შეიყვანეთ 6-ნიშნა OTP",
  greek: "Εισαγάγετε το 6ψήφιο OTP",
  haitian: "Antre OTP 6 chif la",
  hmong: "Sau 6 tus lej OTP",
  hungarian: "Adja meg a 6 számjegyű OTP-t",
  icelandic: "Sláðu inn 6 stafa OTP",
  javanese: "Lebokna 6 digit OTP",
  kazakh: "6 таңбалы OTP енгізіңіз",
  khmer: "បញ្ចូលលេខ OTP 6 ខ្ទង់",
  kurdish: "OTP-ya 6-reqemî binivîse",
  kyrgyz: "6 орундуу OTP киргизиңиз",
  lao: "ກະລຸນາໃສ່ລະຫັດ OTP 6 ຫຼັກ",
  latin: "Inscribe 6-numerum OTP",
  latvian: "Ievadiet 6 ciparu OTP",
  lithuanian: "Įveskite 6 skaitmenų OTP",
  luxembourgish: "Gitt de 6-stellege OTP an",
  macedonian: "Внесете 6-цифрен OTP",
  malagasy: "Ampidiro ny OTP misy tarehimarika 6",
  maltese: "Daħħal l-OTP ta' 6 cifri",
  maori: "Whakaurunga 6-mati OTP",
  mongolian: "6 оронтой OTP оруулна уу",
  myanmar: "၆ လုံးပါသော OTP ကိုရိုက်ထည့်ပါ",
  nepali: "६-अंकको OTP प्रविष्ट गर्नुहोस्",
  norwegian: "Skriv inn 6-sifret OTP",
  pashto: "د 6 عددو OTP ولیکئ",
  persian: "رمز یکبار مصرف ۶ رقمی را وارد کنید",
  romanian: "Introduceți codul OTP din 6 cifre",
  scots: "Enter 6-digit OTP",
  serbian: "Unesite 6-cifreni OTP",
  sesotho: "Kenya OTP ea linomoro tse 6",
  shona: "Isa 6-digit OTP",
  sindhi: "6 انگن وارو OTP داخل ڪريو",
  sinhala: "ඉලක්කම් 6ක OTP ඇතුළත් කරන්න",
  slovak: "Zadajte 6-miestny kód OTP",
  slovenian: "Vnesite 6-mestno kodo OTP",
  sundanese: "Asupkeun 6-digit OTP",
  swedish: "Ange 6-siffrig OTP",
  tajik: "OTP-и 6-рақамаро ворид кунед",
  tatar: "6 санлы OTP кертегез",
  turkmen: "6 belgili OTP giriziň",
  ukrainian: "Введіть 6-значний OTP",
  uyghur: "6 خانىلىق OTP نى كىرگۈزۈڭ",
  uzbek: "6 xonali OTPni kiriting",
  welsh: "Rhowch OTP 6 digid",
  yiddish: "אַרײַנלייגן די 6-ציפֿער OTP",
  irish: "Cuir isteach OTP 6 dhigit",
  "haitian creole": "Antre OTP 6 chif la",
  "traditional chinese": "請輸入6位OTP驗證碼",
  oriya: "6-ଅଙ୍କ ବିଶିଷ୍ଟ OTP ପ୍ରବିଷ୍ଟ କରନ୍ତୁ",
  "malaysian malay": "Masukkan 6 digit OTP",
  malay: "Masukkan 6 digit OTP",
  tagalog: "Maglagay ng 6-digit na OTP",
  burmese: "၆ လုံးပါသော OTP ကို ထည့်သွင်းပါ။",
  hebrew: "הזן קוד OTP בן 6 ספרות",
};

export const SENDING_OTP_MESSAGE = {
  "english (us)": "Sending OTP to",
  "english (uk)": "Sending OTP to",
  english: "Sending OTP to",
  hindi: "ओटीपी भेजा जा रहा है",
  spanish: "Enviando OTP a",
  french: "Envoi de l'OTP à",
  german: "OTP wird gesendet an",
  italian: "Invio OTP a",
  portuguese: "Enviando OTP para",
  russian: "Отправка OTP на",
  japanese: "OTPを送信しています:",
  korean: "OTP를 다음으로 보내는 중:",
  chinese: "正在发送OTP至",
  arabic: "جارٍ إرسال رمز OTP إلى",
  turkish: "OTP şuraya gönderiliyor:",
  dutch: "OTP verzenden naar",
  polish: "Wysyłanie kodu OTP do",
  vietnamese: "Đang gửi OTP đến",
  thai: "กำลังส่ง OTP ไปที่",
  indonesian: "Mengirim OTP ke",
  filipino: "Ipinapadala ang OTP sa",
  bengali: "ওটিপি পাঠানো হচ্ছে",
  tamil: "OTP அனுப்பப்படுகிறது",
  telugu: "OTPని పంపుతోంది",
  kannada: "OTP ಕಳುಹಿಸಲಾಗುತ್ತಿದೆ",
  malayalam: "OTP അയക്കുന്നു",
  marathi: "ओटीपी पाठवत आहे",
  gujarati: "OTP મોકલી રહ્યું છે",
  punjabi: "OTP ਭੇਜਿਆ ਜਾ ਰਿਹਾ ਹੈ",
  urdu: "کو OTP بھیجا جا رہا ہے",
  swahili: "Inatuma OTP kwa",
  yoruba: "Nfi OTP ranse si",
  igbo: "Iziga OTP na",
  hausa: "Aika OTP zuwa",
  amharic: "OTP በመላክ ላይ ለ",
  somali: "Loo dirayo OTP",
  zulu: "Ithumela i-OTP ku-",
  xhosa: "Ithumela i-OTP ku-",
  afrikaans: "Stuur tans OTP na",
  albanian: "Duke dërguar OTP te",
  armenian: "OTP-ի ուղարկում",
  azerbaijani: "OTP göndərilir:",
  basque: "OTP hona bidaltzen:",
  belarusian: "Адпраўка OTP на",
  bosnian: "Slanje OTP-a na",
  bulgarian: "Изпращане на OTP до",
  catalan: "Enviant l'OTP a",
  cebuano: "Nagpadala og OTP sa",
  chichewa: "Kutumiza OTP ku",
  corsican: "Mandà l'OTP à",
  croatian: "Slanje OTP-a na",
  czech: "Odesílání OTP na",
  danish: "Sender OTP til",
  esperanto: "Sendante OTP al",
  estonian: "OTP saatmine aadressile",
  finnish: "Lähetetään OTP kohteeseen",
  frisian: "OTP ferstjoere nei",
  galician: "Enviando OTP a",
  georgian: "OTP-ის გაგზავნა",
  greek: "Αποστολή OTP στο",
  haitian: "Ap voye OTP bay",
  hmong: "Xa OTP mus rau",
  hungarian: "OTP küldése a következőre:",
  icelandic: "Sendir OTP til",
  javanese: "Ngirim OTP menyang",
  kazakh: "OTP жіберілуде:",
  khmer: "កំពុងផ្ញើ OTP ទៅកាន់",
  kurdish: "OTP tê şandin ji bo",
  kyrgyz: "OTP жөнөтүлүүдө:",
  lao: "ກຳລັງສົ່ງ OTP ໄປຫາ",
  latin: "Mittens OTP ad",
  latvian: "Sūta OTP uz",
  lithuanian: "Siunčiamas OTP į",
  luxembourgish: "OTP gëtt geschéckt un",
  macedonian: "Испраќање OTP до",
  malagasy: "Mandefa OTP ho an'ny",
  maltese: "Qed jintbagħat l-OTP lil",
  maori: "Kei te tuku OTP ki a",
  mongolian: "OTP илгээж байна:",
  myanmar: "OTP ပို့နေသည်",
  nepali: "OTP पठाइँदैछ",
  norwegian: "Sender OTP til",
  pashto: "ته OTP لیږل کیږي",
  persian: "ارسال رمز یکبار مصرف به",
  romanian: "Se trimite OTP către",
  scots: "Sendin OTP tae",
  serbian: "Slanje OTP-a na",
  sesotho: "E romela OTP ho",
  shona: "Kutumira OTP ku",
  sindhi: "ڏانهن OTP موڪلي پيو وڃي",
  sinhala: "OTP යවමින් පවතී",
  slovak: "Odosiela sa OTP na",
  slovenian: "Pošiljanje OTP na",
  sundanese: "Ngirimkeun OTP ka",
  swedish: "Skickar OTP till",
  tajik: "Фиристодани OTP ба",
  tatar: "OTP җибәрелә:",
  turkmen: "OTP ugradylýar:",
  ukrainian: "Надсилання OTP на",
  uyghur: "OTP نى ئەۋەتىۋاتىدۇ",
  uzbek: "OTP yuborilmoqda:",
  welsh: "Anfon OTP at",
  yiddish: "שיקן OTP צו",
  irish: "OTP á sheoladh chuig",
  "haitian creole": "Ap voye OTP bay",
  "traditional chinese": "正在發送OTP至",
  oriya: "କୁ OTP ପଠାଯାଉଛି",
  "malaysian malay": "Menghantar OTP ke",
  malay: "Menghantar OTP ke",
  tagalog: "Ipinapadala ang OTP sa",
  burmese: "OTP ပေးပို့နေသည်",
  hebrew: "שולח קוד OTP אל",
};

export const RESEND_OTP_MESSAGE = {
  "english (us)": "Resend OTP",
  "english (uk)": "Resend OTP",
  english: "Resend OTP",
  hindi: "ओटीपी पुनः भेजें",
  spanish: "Reenviar OTP",
  french: "Renvoyer l'OTP",
  german: "OTP erneut senden",
  italian: "Reinvia OTP",
  portuguese: "Reenviar OTP",
  russian: "Отправить OTP повторно",
  japanese: "OTPを再送信",
  korean: "OTP 다시 보내기",
  chinese: "重新发送OTP",
  arabic: "إعادة إرسال OTP",
  turkish: "OTP'yi yeniden gönder",
  dutch: "OTP opnieuw verzenden",
  polish: "Wyślij OTP ponownie",
  vietnamese: "Gửi lại OTP",
  thai: "ส่ง OTP อีกครั้ง",
  indonesian: "Kirim ulang OTP",
  filipino: "Ipadala muli ang OTP",
  bengali: "ওটিপি পুনরায় পাঠান",
  tamil: "OTP மீண்டும் அனுப்பவும்",
  telugu: "OTPను మళ్లీ పంపండి",
  kannada: "OTP ಅನ್ನು ಮರುಕಳುಹಿಸಿ",
  malayalam: "OTP വീണ്ടും അയയ്ക്കുക",
  marathi: "ओटीपी पुन्हा पाठवा",
  gujarati: "OTP ફરી મોકલો",
  punjabi: "OTP ਮੁੜ ਭੇਜੋ",
  urdu: "OTP دوبارہ بھیجیں",
  swahili: "Tuma OTP tena",
  yoruba: "Tun fi OTP ranṣẹ lẹẹkansi",
  igbo: "Zipu OTP ọzọ",
  hausa: "Sake aika OTP",
  amharic: "OTP እንደገና ላክ",
  somali: "Dib u dir OTP",
  zulu: "Thumela i-OTP futhi",
  xhosa: "Thumela i-OTP kwakhona",
  afrikaans: "Stuur OTP weer",
  albanian: "Ridërgo OTP",
  armenian: "Վերաուղարկել OTP",
  azerbaijani: "OTP-ni yenidən göndər",
  basque: "Bidali OTP berriro",
  belarusian: "Адправіць OTP паўторна",
  bosnian: "Ponovo pošalji OTP",
  bulgarian: "Изпрати OTP отново",
  catalan: "Reenvia l'OTP",
  cebuano: "Ipadala pag-usab ang OTP",
  chichewa: "Tumizaninso OTP",
  corsican: "Rimandà l'OTP",
  croatian: "Ponovno pošalji OTP",
  czech: "Znovu odeslat OTP",
  danish: "Send OTP igen",
  esperanto: "Resendu OTP",
  estonian: "Saada OTP uuesti",
  finnish: "Lähetä OTP uudelleen",
  frisian: "OTP opnij ferstjoere",
  galician: "Reenviar OTP",
  georgian: "OTP-ის ხელახლა გაგზავნა",
  greek: "Επανάληψη αποστολής OTP",
  haitian: "Voye OTP ankò",
  hmong: "Xa OTP dua",
  hungarian: "OTP újraküldése",
  icelandic: "Senda OTP aftur",
  javanese: "Kirim ulang OTP",
  kazakh: "OTP-ні қайта жіберу",
  khmer: "ផ្ញើ OTP ម្តងទៀត",
  kurdish: "OTP ji nû ve bişîne",
  kyrgyz: "OTP кайра жөнөтүү",
  lao: "ສົ່ງ OTP ອີກຄັ້ງ",
  latin: "OTP iterum mitte",
  latvian: "Nosūtīt OTP atkārtoti",
  lithuanian: "Siųsti OTP dar kartą",
  luxembourgish: "OTP nach eng Kéier schécken",
  macedonian: "Испрати OTP повторно",
  malagasy: "Alefaso indray OTP",
  maltese: "Erġa' ibgħat OTP",
  maori: "Tukua anō te OTP",
  mongolian: "OTP дахин илгээх",
  myanmar: "OTP ကို ထပ်မံပို့ပါ",
  nepali: "OTP पुनः पठाउनुहोस्",
  norwegian: "Send OTP på nytt",
  pashto: "OTP بیا واستوئ",
  persian: "ارسال مجدد OTP",
  romanian: "Retrimite OTP",
  scots: "Resend OTP",
  serbian: "Ponovo pošalji OTP",
  sesotho: "Romela OTP hape",
  shona: "Tumirazve OTP",
  sindhi: "OTP ٻيهر موڪليو",
  sinhala: "OTP නැවත යවන්න",
  slovak: "Znovu odoslať OTP",
  slovenian: "Ponovno pošlji OTP",
  sundanese: "Kirim deui OTP",
  swedish: "Skicka OTP igen",
  tajik: "OTP-ро дубора фиристед",
  tatar: "OTP яңадан җибәрү",
  turkmen: "OTP-ni gaýtadan ugrat",
  ukrainian: "Надіслати OTP повторно",
  uyghur: "OTP نى قايتا ئەۋەتىش",
  uzbek: "OTP-ni qayta yuborish",
  welsh: "Ail-anfon OTP",
  yiddish: "שיקן OTP ווידער",
  irish: "Seol OTP arís",
  "haitian creole": "Voye OTP ankò",
  "traditional chinese": "重新傳送OTP",
  oriya: "OTP ପୁନଃ ପଠାନ୍ତୁ",
  "malaysian malay": "Hantar semula OTP",
  malay: "Hantar semula OTP",
  tagalog: "Ipadala muli ang OTP",
  burmese: "OTP ကို ပြန်ပို့ပါ",
  hebrew: "שלח OTP מחדש",
};

export const WAIT_BEFORE_TRYING_MESSAGE = {
  english: "Please wait before trying again",
  hindi: "कृपया पुनः प्रयास करने से पहले प्रतीक्षा करें",
  spanish: "Por favor espere antes de intentar de nuevo",
  french: "Veuillez patienter avant de réessayer",
  german: "Bitte warten Sie, bevor Sie es erneut versuchen",
  italian: "Attendere prima di riprovare",
  portuguese: "Por favor aguarde antes de tentar novamente",
  russian: "Пожалуйста, подождите перед повторной попыткой",
  japanese: "再試行する前にお待ちください",
  korean: "다시 시도하기 전에 잠시 기다려 주세요",
  chinese: "请稍等后再试",
  arabic: "يرجى الانتظار قبل المحاولة مرة أخرى",
  turkish: "Tekrar denemeden önce lütfen bekleyin",
  dutch: "Wacht even voordat u het opnieuw probeert",
  polish: "Proszę poczekać przed ponowną próbą",
  vietnamese: "Vui lòng đợi trước khi thử lại",
  thai: "กรุณารอสักครู่ก่อนลองใหม่",
  indonesian: "Harap tunggu sebelum mencoba lagi",
  filipino: "Mangyaring maghintay bago subukang muli",
  bengali: "আবার চেষ্টা করার আগে অনুগ্রহ করে অপেক্ষা করুন",
  tamil: "மீண்டும் முயற்சிக்கும் முன் தயவுசெய்து காத்திருக்கவும்",
  telugu: "దయచేసి మళ్లీ ప్రయత్నించే ముందు వేచి ఉండండి",
  kannada: "ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸುವ ಮೊದಲು ಕಾಯಿರಿ",
  malayalam: "ദയവായി വീണ്ടും ശ്രമിക്കുന്നതിന് മുമ്പ് കാത്തിരിക്കുക",
  marathi: "कृपया पुन्हा प्रयत्न करण्यापूर्वी प्रतीक्षा करा",
  gujarati: "કૃપા કરીને ફરીથી પ્રયાસ કરતા પહેલા રાહ જુઓ",
  punjabi: "ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਇੰਤਜ਼ਾਰ ਕਰੋ",
  urdu: "براہ کرم دوبارہ کوشش کرنے سے پہلے انتظار کریں",
  swahili: "Tafadhali subiri kabla ya kujaribu tena",
  yoruba: "Jọwọ duro diẹ ṣaaju ki o to gbiyanju lẹẹkansi",
  igbo: "Biko chere tupu ị nwaa ọzọ",
  hausa: "Da fatan za a jira kafin a sake gwadawa",
  amharic: "እባክዎ እንደገና ከመሞከር በፊት ይጠብቁ",
  somali: "Fadlan sug ka hor inta aadan mar kale isku dayin",
  zulu: "Sicela ulinde ngaphambi kokuba uzame futhi",
  xhosa: "Nceda ulinde phambi kokuba uzame kwakhona",
  afrikaans: "Wag asseblief voordat jy weer probeer",
  albanian: "Ju lutemi prisni para se të provoni përsëri",
  armenian: "Խնդրում ենք սպասել մինչև կրկին փորձելը",
  azerbaijani: "Zəhmət olmasa yenidən cəhd etməzdən əvvəl gözləyin",
  basque: "Mesedez itxaron berriro saiatu aurretik",
  belarusian: "Калі ласка, пачакайце перад паўторнай спробай",
  bosnian: "Molimo sačekajte prije ponovnog pokušaja",
  bulgarian: "Моля, изчакайте преди да опитате отново",
  catalan: "Si us plau, espereu abans de tornar-ho a intentar",
  cebuano: "Palihug paghulat una sa dili pa mosulay og balik",
  chichewa: "Chonde dikani musanayesere kwa nthawi yina",
  corsican: "Per piacè aspittate prima di pruvà torna",
  croatian: "Molimo pričekajte prije ponovnog pokušaja",
  czech: "Prosím počkejte před dalším pokusem",
  danish: "Vent venligst før du prøver igen",
  esperanto: "Bonvolu atendi antaŭ provi denove",
  estonian: "Palun oodake enne uuesti proovimist",
  finnish: "Odota hetki ennen uudelleen yrittämistä",
  frisian: "Wachtsje asjebleaft eardat jo it opnij besykje",
  galician: "Por favor agarde antes de volver intentalo",
  georgian: "გთხოვთ დაელოდოთ ხელახლა ცდამდე",
  greek: "Παρακαλώ περιμένετε πριν δοκιμάσετε ξανά",
  haitian: "Tanpri tann anvan ou eseye ankò",
  hmong: "Thov tos ua ntej sim dua",
  hungarian: "Kérjük, várjon az újbóli próbálkozás előtt",
  icelandic: "Vinsamlegast bíddu áður en þú reynir aftur",
  javanese: "Mangga ngenteni dhisik sadurunge nyoba maneh",
  kazakh: "Қайталап көрмес бұрын күте тұрыңыз",
  khmer: "សូមរង់ចាំមុនពេលព្យាយាមម្តងទៀត",
  kurdish: "Ji kerema xwe berî dîsa biceribînin li bendê ne",
  kyrgyz: "Кайрадан аракет кылуудан мурун күтө туруңуз",
  lao: "ກະລຸນາລໍຖ້າກ່ອນທີ່ຈະລອງໃໝ່",
  latin: "Quaeso expecta antequam iterum temptes",
  latvian: "Lūdzu uzgaidiet pirms atkārtotas mēģināšanas",
  lithuanian: "Palaukite prieš bandydami dar kartą",
  luxembourgish: "Waart w.e.g. ier Dir et nach emol probéiert",
  macedonian: "Ве молиме почекајте пред да пробате повторно",
  malagasy: "Mba andraso alohan'ny hanandrana indray",
  maltese: "Jekk jogħġbok stenna qabel tipprova mill-ġdid",
  maori: "Tatari koa i mua o te ngana anō",
  mongolian: "Дахин оролдохоос өмнө түр хүлээнэ үү",
  myanmar: "ကျေးဇူးပြု၍ ထပ်မံကြိုးစားခြင်းမပြုမီ စောင့်ပါ",
  nepali: "कृपया फेरि प्रयास गर्नुअघि पर्खनुहोस्",
  norwegian: "Vennligst vent før du prøver igjen",
  pashto: "مهرباني وروسته له دې چې بیا هڅه وکړئ انتظار وکړئ",
  persian: "لطفاً قبل از تلاش مجدد صبر کنید",
  romanian: "Vă rugăm să așteptați înainte de a încerca din nou",
  scots: "Please wait afore tryin again",
  serbian: "Molimo sačekajte pre ponovnog pokušaja",
  sesotho: "Ka kopo ema pele u leka hape",
  shona: "Ndapota mira usati waedza zvakare",
  sindhi: "مهرباني ڪري ٻيهر ڪوشش ڪرڻ کان اڳ انتظار ڪريو",
  sinhala: "කරුණාකර නැවත උත්සාහ කිරීමට පෙර රැඳී සිටින්න",
  slovak: "Prosím počkajte pred ďalším pokusom",
  slovenian: "Prosimo počakajte pred ponovnim poskusom",
  sundanese: "Punten antosan heula sateuacan nyobian deui",
  swedish: "Vänligen vänta innan du försöker igen",
  tajik: "Лутфан пеш аз кӯшиши такрорӣ интизор шавед",
  tatar: "Зинһар, кабат тырышырга кадәр көтегез",
  turkmen: "Täzeden synanyşmazdan öňünden garaşyň",
  ukrainian: "Будь ласка, зачекайте перед повторною спробою",
  uyghur: "قايتا سىناشتىن بۇرۇن ساقلاڭ",
  uzbek: "Iltimos, qayta urinishdan oldin kuting",
  welsh: "Arhoswch cyn ceisio eto os gwelwch yn dda",
  yiddish: "ביטע וואַרטן איידער איר פּרובירט ווידער",
  irish: "Fan le do thoil sula ndéanann tú iarracht arís",
  "haitian creole": "Tanpri tann anvan ou eseye ankò",
  "traditional chinese": "請稍等後再試",
  oriya: "ଦୟାକରି ପୁନର୍ବାର ଚେଷ୍ଟା କରିବା ପୂର୍ବରୁ ଅପେକ୍ଷା କରନ୍ତୁ",
  "malaysian malay": "Sila tunggu sebelum cuba lagi",
  malay: "Sila tunggu sebelum cuba semula",
  tagalog: "Mangyaring maghintay bago subukang muli",
  burmese: "ထပ်မကြိုးစားခင် စောင့်ပါ။",
  hebrew: "אנא המתן לפני שתנסה שוב",
};

export const QUESTION_LIMIT_REACHED_MESSAGE = {
  english:
    "You've hit the question limit for our automated chatbot. Please use the Contact Us section for further assistance.",
  hindi:
    "आपने हमारे स्वचालित चैटबॉट की प्रश्न सीमा पूरी कर ली है। कृपया आगे की सहायता के लिए संपर्क करें अनुभाग का उपयोग करें।",
  spanish:
    "Has alcanzado el límite de preguntas para nuestro chatbot automatizado. Por favor usa la sección Contáctanos para más asistencia.",
  french:
    "Vous avez atteint la limite de questions pour notre chatbot automatisé. Veuillez utiliser la section Nous contacter pour obtenir de l'aide supplémentaire.",
  german:
    "Sie haben das Fragenlimit für unseren automatisierten Chatbot erreicht. Bitte nutzen Sie den Kontakt-Bereich für weitere Unterstützung.",
  italian:
    "Hai raggiunto il limite di domande per il nostro chatbot automatizzato. Si prega di utilizzare la sezione Contattaci per ulteriore assistenza.",
  portuguese:
    "Você atingiu o limite de perguntas para nosso chatbot automatizado. Por favor, use a seção Fale Conosco para mais assistência.",
  russian:
    "Вы достигли лимита вопросов для нашего автоматизированного чатбота. Пожалуйста, используйте раздел «Связаться с нами» для дальнейшей помощи.",
  japanese:
    "自動チャットボットの質問制限に達しました。さらなるサポートについては、お問い合わせセクションをご利用ください。",
  korean:
    "자동 챗봇의 질문 한도에 도달했습니다. 추가 지원을 위해 문의하기 섹션을 이용해 주세요.",
  chinese:
    "您已达到我们自动聊天机器人的问题限制。请使用联系我们部分获取进一步帮助。",
  arabic:
    "لقد وصلت إلى حد الأسئلة لروبوت الدردشة الآلي الخاص بنا. يرجى استخدام قسم اتصل بنا للحصول على مساعدة إضافية.",
  turkish:
    "Otomatik sohbet botumuza yönelik soru sınırına ulaştınız. Daha fazla yardım için lütfen Bize Ulaşın bölümünü kullanın.",
  dutch:
    "U heeft de vraagenlimiet voor onze geautomatiseerde chatbot bereikt. Gebruik het Contact-gedeelte voor verdere ondersteuning.",
  polish:
    "Osiągnąłeś limit pytań dla naszego automatycznego chatbota. Prosimy o skorzystanie z sekcji Skontaktuj się z nami w celu uzyskania dalszej pomocy.",
  vietnamese:
    "Bạn đã đạt đến giới hạn câu hỏi cho chatbot tự động của chúng tôi. Vui lòng sử dụng phần Liên hệ với chúng tôi để được hỗ trợ thêm.",
  thai: "คุณได้ถึงขีดจำกัดคำถามสำหรับแชทบอทอัตโนมัติของเราแล้ว กรุณาใช้ส่วนติดต่อเราเพื่อขอความช่วยเหลือเพิ่มเติม",
  indonesian:
    "Anda telah mencapai batas pertanyaan untuk chatbot otomatis kami. Silakan gunakan bagian Hubungi Kami untuk bantuan lebih lanjut.",
  filipino:
    "Naabot mo na ang limitasyon ng tanong para sa aming automated chatbot. Mangyaring gamitin ang seksyon ng Makipag-ugnayan sa Amin para sa karagdagang tulong.",
  bengali:
    "আপনি আমাদের স্বয়ংক্রিয় চ্যাটবটের প্রশ্ন সীমায় পৌঁছেছেন। আরও সহায়তার জন্য অনুগ্রহ করে আমাদের সাথে যোগাযোগ বিভাগটি ব্যবহার করুন।",
  tamil:
    "எங்கள் தானியங்கி சாட்போட்டின் கேள்வி வரம்பை நீங்கள் அடைந்துவிட்டீர்கள். மேலும் உதவிக்கு எங்களைத் தொடர்பு கொள்ளுங்கள் பகுதியைப் பயன்படுத்தவும்.",
  telugu:
    "మీరు మా ఆటోమేటెడ్ చాట్‌బాట్ కోసం ప్రశ్న పరిమితిని చేరుకున్నారు. మరింత సహాయం కోసం దయచేసి మమ్మల్ని సంప్రదించండి విభాగాన్ని ఉపయోగించండి.",
  kannada:
    "ನೀವು ನಮ್ಮ ಸ್ವಯಂಚಾಲಿತ ಚಾಟ್‌ಬಾಟ್‌ಗಾಗಿ ಪ್ರಶ್ನೆ ಮಿತಿಯನ್ನು ತಲುಪಿದ್ದೀರಿ. ಮತ್ತಷ್ಟು ಸಹಾಯಕ್ಕಾಗಿ ದಯವಿಟ್ಟು ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ ವಿಭಾಗವನ್ನು ಬಳಸಿ.",
  malayalam:
    "ഞങ്ങളുടെ ഓട്ടോമേറ്റഡ് ചാറ്റ്ബോട്ടിന്റെ ചോദ്യ പരിധിയിൽ നിങ്ങൾ എത്തിയിരിക്കുന്നു. കൂടുതൽ സഹായത്തിനായി ദയവായി ഞങ്ങളെ ബന്ധപ്പെടുക വിഭാഗം ഉപയോഗിക്കുക.",
  marathi:
    "तुम्ही आमच्या स्वयंचलित चॅटबॉटची प्रश्न मर्यादा गाठली आहे. कृपया पुढील सहाय्यासाठी आमच्याशी संपर्क साधा विभाग वापरा.",
  gujarati:
    "તમે અમારા સ્વચાલિત ચેટબોટ માટે પ્રશ્ન મર્યાદા પૂર્ણ કરી છે. વધુ સહાયતા માટે કૃપા કરીને અમારો સંપર્ક કરો વિભાગનો ઉપયોગ કરો.",
  punjabi:
    "ਤੁਸੀਂ ਸਾਡੇ ਸਵੈਚਾਲਿਤ ਚੈਟਬੋਟ ਲਈ ਸਵਾਲ ਦੀ ਸੀਮਾ ਪੂਰੀ ਕਰ ਲਈ ਹੈ। ਹੋਰ ਸਹਾਇਤਾ ਲਈ ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਸੈਕਸ਼ਨ ਦੀ ਵਰਤੋਂ ਕਰੋ।",
  urdu: "آپ نے ہمارے خودکار چیٹ بوٹ کے لیے سوال کی حد کو پہنچا دیا ہے۔ مزید مدد کے لیے براہ کرم ہم سے رابطہ کریں سیکشن استعمال کریں۔",
  swahili:
    "Umegusa kikomo cha maswali cha chatbot yetu ya otomatiki. Tafadhali tumia sehemu ya Wasiliana Nasi kwa msaada zaidi.",
  yoruba:
    "O ti de opin ibeere fun chatbot adaṣe wa. Jọwọ lo abala Kan si Wa fun iranlọwọ siwaju sii.",
  igbo: "Ị arịala njedebe ajụjụ maka chatbot akpaka anyị. Biko jiri akụkụ Kpọtụrụ Anyị maka enyemaka ọzọ.",
  hausa:
    "Kun kai iyakar tambayoyi na chatbot ɗin mu na atomatik. Da fatan za a yi amfani da sashin Tuntuɓe Mu don ƙarin taimako.",
  amharic: "ለአውቶማቲክ ቻትቦታችን የጥያቄ ገደብ ደርሰዋል። ለተጨማሪ እርዳታ እባክዎ የእኛን ያግኙን ክፍል ይጠቀሙ።",
  somali:
    "Waxaad gaadhay xadka su'aalaha ee chatbot-keenna otomaatigga ah. Fadlan isticmaal qaybta Nala soo xiriir si aad u hesho caawimaad dheeraad ah.",
  zulu: "Usufinyelele umkhawulo wemibuzo ye-chatbot yethu ezenzakalelayo. Sicela usebenzise ingxenye yethi Xhumana Nathi ukuze uthole usizo olwengeziwe.",
  xhosa:
    "Ufike kumda wemibuzo ye-chatbot yethu ezenzekelayo. Nceda usebenzise icandelo lethi Qhagamshelana Nathi ukuze ufumane uncedo olongezelelweyo.",
  afrikaans:
    "Jy het die vraelimiet vir ons geoutomatiseerde chatbot bereik. Gebruik asseblief die Kontak Ons-afdeling vir verdere bystand.",
  albanian:
    "Keni arritur kufirin e pyetjeve për chatbot-in tonë automatik. Ju lutemi përdorni seksionin Na Kontaktoni për ndihmë të mëtejshme.",
  armenian:
    "Դուք հասել եք մեր ավտոմատացված չատբոտի հարցերի սահմանին: Լրացուցիչ օգնության համար խնդրում ենք օգտագործել Կապ մեզ հետ բաժինը:",
  azerbaijani:
    "Avtomatlaşdırılmış chatbot-umuz üçün sual limitinə çatdınız. Əlavə yardım üçün lütfən Bizimlə Əlaqə bölməsindən istifadə edin.",
  basque:
    "Gure chatbot automatikoaren galdera-muga jo duzu. Mesedez, erabili Gurekin harremanetan jarri atalaren laguntza gehigarrirako.",
  belarusian:
    "Вы дасягнулі ліміту пытанняў для нашага аўтаматызаванага чатбота. Калі ласка, выкарыстоўвайце раздзел «Звярніцеся да нас» для далейшай дапамогі.",
  bosnian:
    "Dostigli ste limit pitanja za naš automatizirani chatbot. Molimo koristite sekciju Kontaktirajte nas za dodatnu pomoć.",
  bulgarian:
    "Достигнахте лимита на въпроси за нашия автоматизиран чатбот. Моля, използвайте секцията Свържете се с нас за допълнителна помощ.",
  catalan:
    "Heu arribat al límit de preguntes per al nostre chatbot automatitzat. Si us plau, utilitzeu la secció Contacteu-nos per obtenir més assistència.",
  cebuano:
    "Naabut na nimo ang limitasyon sa pangutana sa among automated chatbot. Palihug gamita ang bahin sa Pakig-uban kanamo alang sa dugang nga panabang.",
  chichewa:
    "Mwafika pa malire a mafunso a chatbot yathu yodziyendera. Chonde gwiritsani ntchito gawo la Tikumbukireni kuti mupeze chithandizo chowonjerera.",
  corsican:
    "Avete ghjuntu à u limitu di dumande per u nostru chatbot automatizatu. Per piacè aduperate a sezione Cuntattateci per più assistenza.",
  croatian:
    "Dostigli ste ograničenje pitanja za naš automatizirani chatbot. Molimo koristite odjeljak Kontaktirajte nas za dodatnu pomoć.",
  czech:
    "Dosáhli jste limitu otázek pro našeho automatizovaného chatbota. Prosím použijte sekci Kontaktujte nás pro další pomoc.",
  danish:
    "Du har nået spørgsmålsgrænsen for vores automatiserede chatbot. Brug venligst Kontakt os-sektionen for yderligere hjælp.",
  esperanto:
    "Vi atingis la demandon-limon por nia aŭtomata babilroboto. Bonvolu uzi la sekcion Kontaktu Nin por plia helpo.",
  estonian:
    "Olete jõudnud meie automatiseeritud chatboti küsimuste limiidini. Palun kasutage lisaabi saamiseks meie Võta ühendust sektsiooni.",
  finnish:
    "Olet saavuttanut kysymysrajan automaattiselle chatbotillemme. Käytä Ota yhteyttä -osiota lisäavun saamiseksi.",
  frisian:
    "Jo hawwe de fraachlimyt foar ús automatisearre chatbot berikt. Brûk asjebleaft de Kontakt Ús-seksje foar fierdere help.",
  galician:
    "Alcanzaches o límite de preguntas para o noso chatbot automatizado. Por favor usa a sección Contacta connosco para máis asistencia.",
  georgian:
    "თქვენ მიაღწიეთ ჩვენი ავტომატური ჩატბოტის კითხვების ლიმიტს. გთხოვთ გამოიყენოთ დაგვიკავშირდით სექცია დამატებითი დახმარებისთვის.",
  greek:
    "Φτάσατε στο όριο ερωτήσεων για το αυτοματοποιημένο chatbot μας. Παρακαλώ χρησιμοποιήστε την ενότητα Επικοινωνήστε μαζί μας για περαιτέρω βοήθεια.",
  haitian:
    "Ou rive nan limit kesyon yo pou chatbot otomatik nou an. Tanpri sèvi ak seksyon Kontakte Nou an pou pi fè asistans.",
  hmong:
    "Koj tau mus txog qhov kev txwv lus nug rau peb lub chatbot tsis siv neeg. Thov siv qhov Hu rau Peb ntu rau kev pab ntxiv.",
  hungarian:
    "Elérte a kérdések korlátját automatizált chatbotunk esetében. Kérjük, használja a Kapcsolat szakaszt további segítségért.",
  icelandic:
    "Þú hefur náð spurningsmörkunum fyrir sjálfvirka spjallrófann okkar. Vinsamlegast notaðu Hafðu samband við okkur hlutann til að fá frekari aðstoð.",
  javanese:
    "Sampeyan wis tekan watesan pitakonan kanggo chatbot otomatis kita. Mangga gunakake bagean Hubungi Kita kanggo bantuan liyane.",
  kazakh:
    "Сіз біздің автоматтандырылған чатботымыздың сұрақ шегіне жеттіңіз. Қосымша көмек алу үшін Бізбен байланысу бөлімін пайдаланыңыз.",
  khmer:
    "អ្នកបានដល់ដែនកំណត់សំណួរសម្រាប់ chatbot ស្វ័យប្រវត្តិរបស់យើង។ សូមប្រើផ្នែក ទាក់ទងមកយើង សម្រាប់ជំនួយបន្ថែម។",
  kurdish:
    "We gihîştiye sînorê pirsên chatbot-a me ya otomatîk. Ji kerema xwe beşa Bi Me re Têkilî Daynin bikar bînin bo alîkariya zêdetir.",
  kyrgyz:
    "Сиз биздин автоматташтырылган чатботубузга суроолордун чегине жеттиңиз. Кошумча жардам үчүн Биз менен байланышуу бөлүмүн колдонуңуз.",
  lao: "ທ່ານໄດ້ເຖິງຂີດຈຳກັດຄຳຖາມສຳລັບ chatbot ອັດຕະໂນມັດຂອງພວກເຮົາ. ກະລຸນາໃຊ້ພາກສ່ວນ ຕິດຕໍ່ພວກເຮົາ ສຳລັບການຊ່ວຍເຫຼືອເພີ່ມເຕີມ.",
  latin:
    "Limitem quaestionum pro nostro chatbot automatico attigisti. Quaeso utere sectione Nobiscum Contact pro ulteriore auxilio.",
  latvian:
    "Jūs esat sasniedzis jautājumu limitu mūsu automatizētajam čatbotam. Lūdzu, izmantojiet sadaļu Sazinieties ar mums papildu palīdzībai.",
  lithuanian:
    "Pasiekėte klausimų limitą mūsų automatizuotam chatbot'ui. Prašome naudoti skyrių Susisiekite su mumis papildomai pagalbai.",
  luxembourgish:
    "Dir hutt d'Froen-Limit fir eisen automatiséierte Chatbot erreecht. Benotzt w.e.g. de Kontakt Eis Sektioun fir weider Hëllef.",
  macedonian:
    "Го достигнавте лимитот на прашања за нашиот автоматизиран чатбот. Ве молиме користете ја секцијата Контактирајте не за дополнителна помош.",
  malagasy:
    "Nahatratra ny fetra fanontaniana ho ан'ny chatbot automatique nay ianao. Ampiasao ny fizarana Mifandraisa aminay ho an'ny fanampiana fanampiny.",
  maltese:
    "Int laħaqt il-limitu tal-mistoqsijiet għall-chatbot awtomatizzat tagħna. Jekk jogħġbok uża s-sezzjoni Ikkuntattjana għal assistenza ulterjuri.",
  maori:
    "Kua eke koe ki te raina patai mo to maatau chatbot aunoa. Whakamahia te waahanga Whakapā mai ki a maatau mo etahi atu awhina.",
  mongolian:
    "Та манай автомат чатботын асуултын хязгаарт хүрлээ. Нэмэлт тусламж авахын тулд Бидэнтэй холбогдох хэсгийг ашиглана уу.",
  myanmar:
    "သင်သည် ကျွန်ုပ်တို့၏ အလိုအလျောက် chatbot အတွက် မေးခွန်းကန့်သတ်ချက်သို့ ရောက်ရှိခဲ့သည်။ နောက်ထပ်အကူအညီအတွက် ကျွန်ုပ်တို့ကို ဆက်သွယ်ရန် အပိုင်းကို အသုံးပြုပါ။",
  nepali:
    "तपाईंले हाम्रो स्वचालित च्याटबोटको लागि प्रश्न सीमा पुग्नुभयो। थप सहायताको लागि कृपया हामीलाई सम्पर्क गर्नुहोस् खण्ड प्रयोग गर्नुहोस्।",
  norwegian:
    "Du har nådd spørsmålsgrensen for vår automatiserte chatbot. Vennligst bruk Kontakt oss-seksjonen for ytterligere hjelp.",
  pashto:
    "تاسو زموږ د اتوماتیک چټ بوټ د پوښتنو حد ته رسیدلي یاست. د نورو مرستو لپاره مهرباني وکړئ موږ سره اړیکه ونیسئ برخه وکاروئ.",
  persian:
    "شما به حد سوالات ربات چت خودکار ما رسیده‌اید. لطفاً از بخش تماس با ما برای کمک بیشتر استفاده کنید.",
  romanian:
    "Ați atins limita de întrebări pentru chatbot-ul nostru automatizat. Vă rugăm să utilizați secțiunea Contactați-ne pentru asistență suplimentară.",
  scots:
    "Ye've hit the question limit for oor automated chatbot. Please use the Contact Us section for further assistance.",
  serbian:
    "Dostigli ste ograničenje pitanja za naš automatizovani chatbot. Molimo koristite sekciju Kontaktirajte nas za dodatnu pomoć.",
  sesotho:
    "U fihlile tekanyong ea lipotso bakeng sa chatbot ea rona e ikemetseng. Ka kopo sebelisa karolo ea Ikopanye le Rona bakeng sa thuso e eketsehileng.",
  shona:
    "Wasvika pamuganhu wemibvunzo ye-chatbot yedu inoshanda yega. Ndapota shandisa chikamu cheKubata Nesu kuti uwane rumwe rubatsiro.",
  sindhi:
    "توهان اسان جي خودڪار چيٽ بوٽ لاءِ سوال جي حد تي پهچي ويا آهيو. وڌيڪ مدد لاءِ مهرباني ڪري اسان سان رابطو ڪريو حصو استعمال ڪريو.",
  sinhala:
    "ඔබ අපගේ ස්වයංක්‍රීය chatbot සඳහා ප්‍රශ්න සීමාවට ළඟා වී ඇත. අතිරේක සහාය සඳහා කරුණාකර අප සමඟ සම්බන්ධ වන්න කොටස භාවිතා කරන්න.",
  slovak:
    "Dosiahli ste limit otázok pre našeho automatizovaného chatbota. Prosím použite sekciu Kontaktujte nás pre ďalšiu pomoc.",
  slovenian:
    "Dosegli ste omejitev vprašanj za našega avtomatiziranega chatbota. Prosimo, uporabite razdelek Kontaktirajte nas za nadaljnjo pomoč.",
  sundanese:
    "Anjeun parantos ngahontal wates patarosan pikeun chatbot otomatis kami. Punten anggo bagian Kontak Kami kanggo bantosan salajengna.",
  swedish:
    "Du har nått frågebegränsningen för vår automatiserade chatbot. Vänligen använd Kontakta oss-sektionen för ytterligare hjälp.",
  tajik:
    "Шумо ба ҳадди саволҳо барои чатботи худкори мо расидаед. Лутфан бахши Бо мо тамос гиред-ро барои кӯмаки иловагӣ истифода баред.",
  tatar:
    "Сез безнең автомат чатбот өчен сорау чигенә життегез. Өстәмә ярдәм өчен зинһар Безнең белән элемтәгә керегез бүлеген кулланыгыз.",
  turkmen:
    "Awtomatiki çatbotymyz üçin sorag çägini ýetdiňiz. Goşmaça kömek üçin Biziň bilen habarlaşyň bölümini ulanyň.",
  ukrainian:
    'Ви досягли ліміту запитань для нашого автоматизованого чатбота. Будь ласка, використовуйте розділ "Зв\'яжіться з нами" для подальшої допомоги.',
  uyghur:
    "سىز بىزنىڭ ئاپتوماتىك چات ماشىنىمىزنىڭ سوئال چېكىگە يەتتىڭىز. قوشۇمچە ياردەم ئۈچۈن بىز بىلەن ئالاقىلىشىش بۆلىكىنى ئىشلىتىڭ.",
  uzbek:
    "Siz bizning avtomatik chatbot uchun savol chegarasiga yetdingiz. Qo'shimcha yordam uchun Biz bilan bog'lanish bo'limidan foydalaning.",
  welsh:
    "Rydych wedi cyrraedd y terfyn cwestiynau ar gyfer ein chatbot awtomataidd. Defnyddiwch yr adran Cysylltwch â Ni am gymorth pellach.",
  yiddish:
    "איר האָט דערגרייכט די פֿראַגע גרענעץ פֿאַר אונדזער אָטאַמייטיד טשאַטבאָט. ביטע נוצן די קאָנטאַקט אונדז אָפּטיילונג פֿאַר ווייַטער הילף.",
  irish:
    "Tá an teorainn ceiste don chatbot uathoibrithe againn bainte amach agat. Úsáid an rannán Déan Teagmháil Linn le haghaidh cúnaimh bhreise.",
  "haitian creole":
    "Ou rive nan limit kesyon yo pou chatbot otomatik nou an. Tanpri sèvi ak seksyon Kontakte Nou an pou pi fè asistans.",
  "traditional chinese":
    "您已達到我們自動聊天機器人的問題限制。請使用聯絡我們部分獲取進一步幫助。",
  oriya:
    "ଆମର ସ୍ୱୟଂଚାଳିତ ଚାଟବଟ୍ ପାଇଁ ଆପଣ ପ୍ରଶ୍ନ ସୀମା ପହଞ୍ଚିଛନ୍ତି। ଅଧିକ ସହାୟତା ପାଇଁ ଦୟାକରି ଆମକୁ ଯୋଗାଯୋଗ କରନ୍ତୁ ବିଭାଗ ବ୍ୟବହାର କରନ୍ତୁ।",
  "malaysian malay":
    "Anda telah mencapai had soalan untuk chatbot automatik kami. Sila gunakan bahagian Hubungi Kami untuk bantuan lanjut.",
  malay:
    "Anda telah sampai ke had soalan untuk chatbot automatik kami. Sila guna bahagian Hubungi Kami untuk bantuan selanjutnya.",
  tagalog:
    "Naabot mo na ang limitasyon sa tanong para sa aming automated na chatbot. Mangyaring gamitin ang seksyong Makipag-ugnayan sa Amin para sa karagdagang tulong.",
  burmese:
    "ကျွန်ုပ်တို့၏ အလိုအလျောက် chatbot အတွက် မေးခွန်းကန့်သတ်ချက်ကို သင်ကျော်လွန်သွားပါပြီ။ နောက်ထပ်အကူအညီအတွက် ကျေးဇူးပြု၍ ကျွန်ုပ်တို့ထံ ဆက်သွယ်ရန် ကဏ္ဍကို အသုံးပြုပါ။",
  hebrew:
    "הגעת למגבלת השאלות עבור הצ'אטבוט האוטומטי שלנו. אנא השתמש במקטע צור קשר לקבלת סיוע נוסף.",
};

export const SOMETHING_WENT_WRONG_MESSAGE = {
  english: "Something went wrong please try again later.",
  hindi: "कुछ गलत हुआ है कृपया बाद में पुनः प्रयास करें।",
  spanish: "Algo salió mal, por favor inténtelo de nuevo más tarde.",
  french: "Quelque chose s'est mal passé, veuillez réessayer plus tard.",
  german: "Etwas ist schiefgelaufen, bitte versuchen Sie es später erneut.",
  italian: "Qualcosa è andato storto, riprova più tardi.",
  portuguese: "Algo deu errado, por favor tente novamente mais tarde.",
  russian: "Что-то пошло не так, попробуйте позже.",
  japanese: "何かが間違っています。後でもう一度お試しください。",
  korean: "문제가 발생했습니다. 나중에 다시 시도해 주세요.",
  chinese: "出现了问题，请稍后再试。",
  arabic: "حدث خطأ ما، يرجى المحاولة مرة أخرى لاحقاً.",
  turkish: "Bir şeyler yanlış gitti, lütfen daha sonra tekrar deneyin.",
  dutch: "Er is iets misgegaan, probeer het later opnieuw.",
  polish: "Coś poszło nie tak, spróbuj ponownie później.",
  vietnamese: "Đã xảy ra lỗi, vui lòng thử lại sau.",
  thai: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้งในภายหลัง",
  indonesian: "Terjadi kesalahan, silakan coba lagi nanti.",
  filipino: "May nangyaring mali, subukan ulit mamaya.",
  bengali: "কিছু ভুল হয়েছে অনুগ্রহ করে পরে আবার চেষ্টা করুন।",
  tamil: "ஏதோ தவறு நடந்துள்ளது, பிறகு மீண்டும் முயற்சிக்கவும்.",
  telugu: "ఏదో తప్పు జరిగింది దయచేసి తర్వాత మళ్లీ ప్రయత్నించండి।",
  kannada: "ಏನೋ ತಪ್ಪಾಗಿದೆ ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ।",
  malayalam: "എന്തോ തെറ്റുപറ്റി, ദയവായി പിന്നീട് വീണ്ടും ശ്രമിക്കുക।",
  marathi: "काहीतरी चूक झाली आहे कृपया नंतर पुन्हा प्रयत्न करा।",
  gujarati: "કંઈક ખોટું થયું છે કૃપા કરીને પછીથી ફરીથી પ્રયાસ કરો।",
  punjabi: "ਕੁਝ ਗਲਤ ਹੋਇਆ ਹੈ ਕਿਰਪਾ ਕਰਕੇ ਬਾਅਦ ਵਿੱਚ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
  urdu: "کچھ غلط ہوا ہے براہ کرم بعد میں دوبارہ کوشش کریں۔",
  swahili: "Kuna tatizo lilitokea, tafadhali jaribu tena baadaye.",
  yoruba: "Nkankan lo ṣẹlẹ ti ko dara, jọwọ gbiyanju lẹẹkansi nigbamii.",
  igbo: "Ihe mebiri emebi, biko nwalee ọzọ mgbe emechaa.",
  hausa: "Wani abu ya faru mara kyau, da fatan za a sake gwadawa daga baya.",
  amharic: "የሆነ ነገር ስህተት ሆኗል፣ እባክዎ በኋላ እንደገና ይሞክሩ።",
  somali: "Wax qaldan ayaa dhacay, fadlan isku day mar dambe.",
  zulu: "Kukhona okwenzeka okungalungile, sicela uzame futhi kamuva.",
  xhosa: "Kuye kwenzeka into engalunganga, nceda uzame kwakhona kamva.",
  afrikaans: "Iets het verkeerd geloop, probeer asseblief later weer.",
  albanian: "Diçka shkoi keq, ju lutemi provoni përsëri më vonë.",
  armenian: "Ինչ-որ բան սխալ գնաց, խնդրում ենք փորձել ավելի ուշ:",
  azerbaijani: "Nəsə səhv getdi, zəhmət olmasa sonra yenidən cəhd edin.",
  basque: "Zerbait gaizki joan da, mesedez saiatu berriro geroago.",
  belarusian: "Нешта пайшло не так, калі ласка, паспрабуйце пазней.",
  bosnian: "Nešto je pošlo po zlu, molimo pokušajte ponovo kasnije.",
  bulgarian: "Нещо се обърка, моля опитайте отново по-късно.",
  catalan:
    "Alguna cosa ha anat malament, si us plau torneu-ho a provar més tard.",
  cebuano: "May nahitabo nga sayup, palihug sulay og balik sa ulahi.",
  chichewa: "Chinachake chilakwika, chonde yesaninso pambuyo pake.",
  corsican: "Qualcosa hè andatu male, per piacè pruvate torna più tardi.",
  croatian: "Nešto je pošlo po zlu, molimo pokušajte ponovno kasnije.",
  czech: "Něco se pokazilo, zkuste to prosím později znovu.",
  danish: "Noget gik galt, prøv venligst igen senere.",
  esperanto: "Io malsukcesis, bonvolu reprovi poste.",
  estonian: "Midagi läks valesti, palun proovige hiljem uuesti.",
  finnish: "Jokin meni pieleen, yritä myöhemmin uudelleen.",
  frisian: "Der is wat misgien, probearje it letter opnij.",
  galician: "Algo saíu mal, por favor téntao de novo máis tarde.",
  georgian: "რაღაც არასწორად მოხდა, გთხოვთ მოგვიანებით ისევ სცადოთ.",
  greek: "Κάτι πήγε στραβά, παρακαλώ δοκιμάστε ξανά αργότερα.",
  haitian: "Gen bagay ki mal pase, tanpri eseye ankò pi ta.",
  hmong: "Ib yam dab tsi tsis ncaj ncees lawm, thov sim dua tom qab.",
  hungarian: "Valami hiba történt, kérjük próbálja újra később.",
  icelandic: "Eitthvað fór úrskeiðis, vinsamlegast reyndu aftur síðar.",
  javanese: "Ana sing salah, coba maneh mengko.",
  kazakh: "Бір нәрсе дұрыс болмады, кейінірек қайталап көріңіз.",
  khmer: "មានអ្វីមួយខុសឆ្គង សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ។",
  kurdish: "Tiştek şaş çû, ji kerema xwe paşê dîsa biceribîne.",
  kyrgyz: "Бир нерсе туура эмес болду, кийинчерээк кайрадан аракет кылыңыз.",
  lao: "ມີບາງຢ່າງຜິດພາດ ກະລຸນາລອງໃໝ່ໃນພາຍຫຼັງ.",
  latin: "Aliquid male cessit, quaeso iterum temptes postea.",
  latvian: "Kaut kas nogāja greizi, lūdzu mēģiniet vēlāk.",
  lithuanian: "Kažkas negerai, bandykite dar kartą vėliau.",
  luxembourgish: "Eppes ass schif gaangen, probéiert w.e.g. méi spéit erëm.",
  macedonian: "Нешто тргна наопаку, ве молиме обидете се повторно подоцна.",
  malagasy: "Nisy zavatra tsy nety, andramo indray avy eo.",
  maltese: "Xi ħaġa marret ħażin, jekk jogħġbok erġa' pprova aktar tard.",
  maori: "He ararua i roto, whakamātauria anō i muri mai.",
  mongolian: "Ямар нэг зүйл буруу болсон, дараа дахин оролдоно уу.",
  myanmar: "တစ်ခုခု မှားသွားပါသည်၊ နောက်မှ ထပ်ကြိုးစားကြည့်ပါ။",
  nepali: "केहि गलत भयो कृपया पछि फेरि प्रयास गर्नुहोस्।",
  norwegian: "Noe gikk galt, vennligst prøv igjen senere.",
  pashto: "یو څه ناسمه شوه، مهرباني وروسته بیا هڅه وکړئ.",
  persian: "مشکلی پیش آمده، لطفاً بعداً دوباره تلاش کنید.",
  romanian: "Ceva nu a mers bine, vă rugăm să încercați din nou mai târziu.",
  scots: "Somethin went wrang, please try again later.",
  serbian: "Nešto je pošlo po zlu, molimo pokušajte ponovo kasnije.",
  sesotho: "Ho etsahala ntho e fosahetseng, ka kopo leka hape ka mora nako.",
  shona: "Chimwe chinhu chisina kuenda zvakanaka, edza zvakare gare gare.",
  sindhi: "ڪجهه غلط ٿيو آهي، مهرباني ڪري بعد ۾ ٻيهر ڪوشش ڪريو.",
  sinhala: "යමක් වැරදී ගියා, කරුණාකර පසුව නැවත උත්සාහ කරන්න.",
  slovak: "Niečo sa pokazilo, skúste to prosím neskôr znovu.",
  slovenian: "Kaj je šlo narobe, poskusite znova pozneje.",
  sundanese: "Aya nu salah, coba deui engké.",
  swedish: "Något gick fel, försök igen senare.",
  tajik: "Чизе нодуруст шуд, лутфан баъдтар такрор кунед.",
  tatar: "Берәр нәрсә дөрес булмады, зинһар соңрак кабат тырышыгыз.",
  turkmen: "Bir zat nädogry boldy, soňra gaýtadan synanyşyň.",
  ukrainian: "Щось пішло не так, будь ласка, спробуйте пізніше.",
  uyghur: "بىر ئىش خاتا بولدى، كېيىن قايتا سىناپ بېقىڭ.",
  uzbek: "Nimadir noto'g'ri ketdi, iltimos keyinroq qayta urinib ko'ring.",
  welsh: "Aeth rhywbeth o'i le, rhowch gynnig arall arni yn nes ymlaen.",
  yiddish: "עפּעס איז אַרויס פאַלש, ביטע פּרובירן ווידער שפּעטער.",
  irish: "Chuaigh rud éigin mícheart, bain triail eile as ar ball.",
  "haitian creole": "Gen bagay ki mal pase, tanpri eseye ankò pi ta.",
  "traditional chinese": "出現了問題，請稍後再試。",
  oriya: "କିଛି ଭୁଲ ହୋଇଛି ଦୟାକରି ପରେ ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।",
  "malaysian malay": "Sesuatu yang tidak kena berlaku, sila cuba lagi nanti.",
  malay: "Ada masalah, sila cuba lagi kemudian.",
  tagalog: "Nagkaproblema, pakisubukang muli sa ibang pagkakataon.",
  burmese: "တစ်ခုခုမှားသွားလို့ နောက်မှထပ်ကြိုးစားပါ။",
  hebrew: "משהו השתבש, אנא נסה שוב מאוחר יותר.",
};

export const defaultConversations = [
  {
    _id: "1",
    lastMessage: {
      isAiBot: true,
      drawFlowId: "0",
      hasAnswer: false,
      nodeTitle:
        "Absolutely! Here are some helpful links to get started with ChatbotBuilder.net:\n\n- [Home](https://chatbotbuilder.net)\n- [Use Cases](https://chatbotbuilder.net/use-cases)\n- [Pricing](https://chatbotbuilder.net/pricing)\n- [Templates](https://chatbotbuilder.net/templates)\n- [Docs](https://chatbotbuilder.net/docs)\n\nWould you like to explore templates or see a live demo?",
      userAnswer:
        "Got any quick links so I don’t have to go on a treasure hunt? ",
      nodeType: "default",
      reaction: null,
      feedback: null,
      answeredQuery: false,
      _id: "msg-001",
      date: "2025-05-26T06:10:33.738Z",
    },
  },
  {
    _id: "2",
    lastMessage: {
      isAiBot: true,
      drawFlowId: "0",
      hasAnswer: false,
      nodeTitle:
        "ChatbotBuilder.net is a drag-and-drop chatbot builder designed for marketers, agencies, and SaaS teams. No code needed—just your imagination.\n\nYou can create bots for:\n- Lead gen\n- Customer support\n- Product tours\n- Surveys & quizzes\n\nWanna see how it works?",
      userAnswer:
        "Is this the thing that lets me build bots without selling my soul to code? ",
      nodeType: "default",
      reaction: null,
      feedback: null,
      answeredQuery: false,
      _id: "msg-002",
      date: "2025-05-26T06:11:29.880Z",
    },
  },
  {
    _id: "3",
    lastMessage: {
      isAiBot: true,
      drawFlowId: "0",
      hasAnswer: false,
      nodeTitle:
        "This one's cool: We just launched a live preview editor with real-time flow syncing. That means you can edit your chatbot and see it update instantly—like Notion, but for bots. ✨",
      userAnswer: "OHH stop—did you just say real-time sync? That’s hot ",
      nodeType: "default",
      reaction: null,
      feedback: null,
      answeredQuery: false,
      _id: "msg-003",
      date: "2025-05-26T06:12:50.666Z",
    },
  },
];
